export interface IJrwaNode {
  id: string;
  code: string;
  label: string;
  children: IJrwaNode[];
  /** custom = added by user, not from the official JRWA */
  custom?: boolean;
}

export const JRWA_GMINY: IJrwaNode[] = [
  {
    "id": "0",
    "code": "0",
    "label": "ZARZĄDZANIE GMINĄ I JEJ REPREZENTACJA",
    "children": [
      {
        "id": "00",
        "code": "00",
        "label": "Organy kolegialne i jednoosobowe gminy",
        "children": [
          {
            "id": "000",
            "code": "000",
            "label": "Rada gminy",
            "children": [
              {
                "id": "0000",
                "code": "0000",
                "label": "Organizacja pracy rady gminy",
                "children": []
              },
              {
                "id": "0001",
                "code": "0001",
                "label": "Planowanie i sprawozdawczość z prac rady gminy",
                "children": []
              },
              {
                "id": "0002",
                "code": "0002",
                "label": "Sesje rady gminy",
                "children": []
              },
              {
                "id": "0003",
                "code": "0003",
                "label": "Wnioski i interpelacje radnych",
                "children": []
              },
              {
                "id": "0004",
                "code": "0004",
                "label": "Przewodniczący rady gminy",
                "children": []
              },
              {
                "id": "0005",
                "code": "0005",
                "label": "Wnioski i postulaty mieszkańców i innych podmiotów do rady gminy oraz spotkania z mieszkańcami i innymi podmiotami",
                "children": []
              },
              {
                "id": "0006",
                "code": "0006",
                "label": "Projekty uchwał rady gminy",
                "children": []
              },
              {
                "id": "0007",
                "code": "0007",
                "label": "Uchwały rady gminy",
                "children": []
              },
              {
                "id": "0008",
                "code": "0008",
                "label": "Realizacja uchwał rady gminy i jej monitorowanie",
                "children": []
              }
            ]
          },
          {
            "id": "001",
            "code": "001",
            "label": "Komisje, zespoły i inne organy kolegialne rady gminy",
            "children": [
              {
                "id": "0010",
                "code": "0010",
                "label": "Powoływanie i organizacja pracy komisji, zespołów i innych organów kolegialnych rady gminy",
                "children": []
              },
              {
                "id": "0011",
                "code": "0011",
                "label": "Planowanie i sprawozdawczość z prac komisji, zespołów i innych organów kolegialnych rady gminy",
                "children": []
              },
              {
                "id": "0012",
                "code": "0012",
                "label": "Posiedzenia komisji, zespołów i innych organów kolegialnych rady gminy",
                "children": []
              },
              {
                "id": "0013",
                "code": "0013",
                "label": "Projekty uchwał komisji, zespołów i innych organów kolegialnych rady gminy",
                "children": []
              },
              {
                "id": "0014",
                "code": "0014",
                "label": "Uchwały komisji, zespołów i innych organów kolegialnych rady gminy",
                "children": []
              },
              {
                "id": "0015",
                "code": "0015",
                "label": "Realizacja uchwał komisji, zespołów i innych organów kolegialnych rady gminy",
                "children": []
              }
            ]
          },
          {
            "id": "002",
            "code": "002",
            "label": "Organy uchwałodawcze jednostek pomocniczych gminy",
            "children": [
              {
                "id": "0020",
                "code": "0020",
                "label": "Organizacja pracy organów uchwałodawczych jednostek pomocniczych gminy",
                "children": []
              },
              {
                "id": "0021",
                "code": "0021",
                "label": "Posiedzenia (zebrania) organów uchwałodawczych jednostek pomocniczych gminy",
                "children": []
              }
            ]
          },
          {
            "id": "003",
            "code": "003",
            "label": "Młodzieżowa rada gminy i inne rady utworzone przez radę gminy",
            "children": [
              {
                "id": "0030",
                "code": "0030",
                "label": "Wybory do młodzieżowej rady gminy",
                "children": []
              },
              {
                "id": "0031",
                "code": "0031",
                "label": "Prace młodzieżowej rady gminy",
                "children": []
              },
              {
                "id": "0032",
                "code": "0032",
                "label": "Wybory do innych rad utworzonych przez radę gminy",
                "children": []
              },
              {
                "id": "0033",
                "code": "0033",
                "label": "Prace innych rad utworzonych przez radę gminy",
                "children": []
              }
            ]
          },
          {
            "id": "004",
            "code": "004",
            "label": "Obsługa radnych gminy",
            "children": [
              {
                "id": "0040",
                "code": "0040",
                "label": "Wygaśnięcie mandatu radnego",
                "children": []
              },
              {
                "id": "0041",
                "code": "0041",
                "label": "Kluby radnych gminy",
                "children": []
              },
              {
                "id": "0042",
                "code": "0042",
                "label": "Sprawy osobowe radnych gminy",
                "children": []
              },
              {
                "id": "0043",
                "code": "0043",
                "label": "Oświadczenia majątkowe radnych gminy lub o członkach ich rodzin",
                "children": []
              },
              {
                "id": "0044",
                "code": "0044",
                "label": "Inne oświadczenia radnych gminy lub o członkach ich rodzin",
                "children": []
              },
              {
                "id": "0045",
                "code": "0045",
                "label": "Podnoszenie kompetencji radnych gminy",
                "children": []
              }
            ]
          },
          {
            "id": "005",
            "code": "005",
            "label": "Wójt (burmistrz, prezydent miasta) jako organ gminy",
            "children": [
              {
                "id": "0050",
                "code": "0050",
                "label": "Zbiór zarządzeń, ogłoszeń i obwieszczeń wójta (burmistrza, prezydenta miasta) jako organu gminy",
                "children": []
              },
              {
                "id": "0051",
                "code": "0051",
                "label": "Realizacja zarządzeń, ogłoszeń i obwieszczeń wójta (burmistrza, prezydent miasta) jako organu gminy",
                "children": []
              },
              {
                "id": "0052",
                "code": "0052",
                "label": "Upoważnianie osób (podmiotów) do działania w imieniu wójta (burmistrza, prezydenta miasta) jako organu gminy",
                "children": []
              },
              {
                "id": "0053",
                "code": "0053",
                "label": "Kolegium wójta (burmistrza, prezydenta miasta)",
                "children": []
              },
              {
                "id": "0054",
                "code": "0054",
                "label": "Patronat wójta (burmistrza, prezydenta miasta)",
                "children": []
              },
              {
                "id": "0055",
                "code": "0055",
                "label": "Narady wójta (burmistrza, prezydenta miasta) z sołtysami",
                "children": []
              },
              {
                "id": "0056",
                "code": "0056",
                "label": "Spotkania wójta (burmistrza, prezydenta miasta) z mieszkańcami",
                "children": []
              },
              {
                "id": "0057",
                "code": "0057",
                "label": "Sprawozdawczość z działalności wójta (burmistrza, prezydenta miasta)",
                "children": []
              },
              {
                "id": "0058",
                "code": "0058",
                "label": "Wygaśnięcie mandatu wójta (burmistrza, prezydenta miasta)",
                "children": []
              }
            ]
          },
          {
            "id": "006",
            "code": "006",
            "label": "Zawieszenie organów gminy (zarząd komisaryczny)",
            "children": []
          },
          {
            "id": "007",
            "code": "007",
            "label": "Działania interwencyjne organów administracji rządowej w ramach nadzoru nad organami gminy",
            "children": []
          }
        ]
      },
      {
        "id": "01",
        "code": "01",
        "label": "Podział terytorialny, organizacja, zarządzanie jakością, herby, flagi, emblematy, insygnia lub inne symbole",
        "children": [
          {
            "id": "010",
            "code": "010",
            "label": "Wyjaśnienia, interpretacje, opinie, akty prawne dotyczące działań w zakresie podziału terytorialnego, organizacji, ustalania herbów, flag, emblematów, insygniów lub innych symboli",
            "children": []
          },
          {
            "id": "011",
            "code": "011",
            "label": "Podział terytorialny",
            "children": [
              {
                "id": "0110",
                "code": "0110",
                "label": "Tworzenie, łączenie i znoszenie jednostek podziału terytorialnego oraz zmiany ich granic",
                "children": []
              },
              {
                "id": "0111",
                "code": "0111",
                "label": "Tworzenie, łączenie i znoszenie sołectw, dzielnic itp. oraz zmiany ich granic",
                "children": []
              },
              {
                "id": "0112",
                "code": "0112",
                "label": "Nadawanie statusu miasta",
                "children": []
              },
              {
                "id": "0113",
                "code": "0113",
                "label": "Ustalanie i zmiany nazw miejscowości i obiektów fizjograficznych",
                "children": []
              }
            ]
          },
          {
            "id": "012",
            "code": "012",
            "label": "Organizacja gminy",
            "children": [
              {
                "id": "0120",
                "code": "0120",
                "label": "Statut gminy i jego zmiany, statuty jednostek pomocniczych oraz inne sprawy z zakresu ich organizacji",
                "children": []
              },
              {
                "id": "0121",
                "code": "0121",
                "label": "Organizacja (w tym tworzenie, likwidacja) urzędów obsługujących organy gminy",
                "children": []
              },
              {
                "id": "0122",
                "code": "0122",
                "label": "Organizacja jednostek organizacyjnych, stanowiących aparat pomocniczy kierowników powiatowych służb, inspekcji i straży",
                "children": []
              },
              {
                "id": "0123",
                "code": "0123",
                "label": "Tworzenie, łączenie, przekształcanie i likwidacja samorządowych jednostek organizacyjnych oraz ich organizacja",
                "children": []
              },
              {
                "id": "0124",
                "code": "0124",
                "label": "Organizacja innych jednostek organizacyjnych niż jednostki zależne od gminy",
                "children": []
              }
            ]
          },
          {
            "id": "013",
            "code": "013",
            "label": "Herby, flagi, emblematy, insygnia, odznaczenia, medale lub inne symbole gminy i jej jednostek",
            "children": []
          },
          {
            "id": "014",
            "code": "014",
            "label": "Systemy zarządzania jakością",
            "children": [
              {
                "id": "0140",
                "code": "0140",
                "label": "Wdrażanie systemu zarządzania jakością",
                "children": []
              },
              {
                "id": "0141",
                "code": "0141",
                "label": "Polityka jakości i księga jakości oraz ich zmiany",
                "children": []
              },
              {
                "id": "0142",
                "code": "0142",
                "label": "Procedury i instrukcje dotyczące zarządzania jakością oraz ich zmiany",
                "children": []
              },
              {
                "id": "0143",
                "code": "0143",
                "label": "Karty usług i karty informacyjne w systemie zarządzania jakością oraz ich zmiany",
                "children": []
              },
              {
                "id": "0144",
                "code": "0144",
                "label": "Audyty jakości zewnętrzne",
                "children": []
              },
              {
                "id": "0145",
                "code": "0145",
                "label": "Audyty jakości wewnętrzne",
                "children": []
              },
              {
                "id": "0146",
                "code": "0146",
                "label": "Doskonalenie systemu zarządzania jakością",
                "children": []
              },
              {
                "id": "0147",
                "code": "0147",
                "label": "Prowadzenie i koordynacja działań w systemie zarządzania jakością",
                "children": []
              }
            ]
          },
          {
            "id": "015",
            "code": "015",
            "label": "Usprawnianie organizacji urzędów, wdrażanie nowoczesnych metod zarządzania",
            "children": []
          }
        ]
      },
      {
        "id": "02",
        "code": "02",
        "label": "Udział gminy w tworzeniu i działalności innych jednostek organizacyjnych oraz nadzór właścicielski gminy",
        "children": [
          {
            "id": "020",
            "code": "020",
            "label": "Wyjaśnienia, interpretacje, opinie, akty prawne dotyczące udziału gminy w tworzeniu i działalności innych jednostek oraz nadzoru właścicielskiego gminy",
            "children": []
          },
          {
            "id": "021",
            "code": "021",
            "label": "Udział gminy w tworzeniu związków międzygminnych, stowarzyszeń lub porozumień oraz ich organizacja i zmiany",
            "children": []
          },
          {
            "id": "022",
            "code": "022",
            "label": "Monitorowanie przez gminę działalności związków międzygminnych i stowarzyszeń oraz sposobu funkcjonowania porozumień",
            "children": []
          },
          {
            "id": "023",
            "code": "023",
            "label": "Nadzór właścicielski gminy",
            "children": [
              {
                "id": "0230",
                "code": "0230",
                "label": "Tworzenie przez gminę spółek i fundacji oraz ich likwidowanie",
                "children": []
              },
              {
                "id": "0231",
                "code": "0231",
                "label": "Przystępowanie do spółek i fundacji",
                "children": []
              },
              {
                "id": "0232",
                "code": "0232",
                "label": "Realizacja nadzoru właścicielskiego",
                "children": []
              }
            ]
          }
        ]
      },
      {
        "id": "03",
        "code": "03",
        "label": "Współdziałanie gminy z innymi jednostkami organizacyjnymi w kraju i za granicą",
        "children": [
          {
            "id": "030",
            "code": "030",
            "label": "Wyjaśnienia, interpretacje, opinie, akty prawne dotyczące współdziałania gminy z innymi jednostkami organizacyjnymi",
            "children": []
          },
          {
            "id": "031",
            "code": "031",
            "label": "Zawieranie i realizacja porozumień gminy z organami administracji państwowej lub samorządowej",
            "children": []
          },
          {
            "id": "032",
            "code": "032",
            "label": "Zawieranie umów w zakresie realizacji zadań gminy i monitorowanie ich wykonania",
            "children": []
          },
          {
            "id": "033",
            "code": "033",
            "label": "Nawiązywanie kontaktów i określanie zakresu współdziałania gminy i jej jednostek organizacyjnych z innymi podmiotami lub jednostkami organizacyjnymi na gruncie krajowym",
            "children": []
          },
          {
            "id": "034",
            "code": "034",
            "label": "Działalność gminy w sprawach zagranicznych",
            "children": [
              {
                "id": "0340",
                "code": "0340",
                "label": "Programowanie, określanie strategii i planów w zakresie współdziałania z partnerami zagranicznymi",
                "children": []
              },
              {
                "id": "0341",
                "code": "0341",
                "label": "Nawiązywanie kontaktów i określanie zakresu współpracy gminy oraz jej jednostek organizacyjnych w sprawach zagranicznych",
                "children": []
              },
              {
                "id": "0342",
                "code": "0342",
                "label": "Wyjazdy zagraniczne przedstawicieli gminy",
                "children": []
              },
              {
                "id": "0343",
                "code": "0343",
                "label": "Przyjmowanie przedstawicieli i gości z zagranicy",
                "children": []
              }
            ]
          },
          {
            "id": "035",
            "code": "035",
            "label": "Zjazdy, konferencje, seminaria, sympozja, fora",
            "children": [
              {
                "id": "0350",
                "code": "0350",
                "label": "Własne zjazdy, konferencje, seminaria, sympozja, fora",
                "children": []
              },
              {
                "id": "0351",
                "code": "0351",
                "label": "Udział w obcych zjazdach, konferencjach, seminariach, sympozjach, forach",
                "children": []
              }
            ]
          }
        ]
      },
      {
        "id": "04",
        "code": "04",
        "label": "Programy i projekty współfinansowane ze środków zewnętrznych, w tym Unii Europejskiej",
        "children": [
          {
            "id": "040",
            "code": "040",
            "label": "Wyjaśnienia, interpretacje, opinie, akty prawne dotyczące zagadnień z zakresu programów i projektów finansowanych ze środków zewnętrznych",
            "children": []
          },
          {
            "id": "041",
            "code": "041",
            "label": "Wnioskowanie o udział w programach i projektach finansowanych ze środków zewnętrznych",
            "children": []
          },
          {
            "id": "042",
            "code": "042",
            "label": "Realizacja programów i projektów finansowanych ze środków zewnętrznych",
            "children": []
          }
        ]
      },
      {
        "id": "05",
        "code": "05",
        "label": "Reprezentacja i promowanie gminy",
        "children": [
          {
            "id": "050",
            "code": "050",
            "label": "Wyjaśnienia, interpretacje, opinie, akty prawne w zakresie reprezentacji i promowania gminy",
            "children": []
          },
          {
            "id": "051",
            "code": "051",
            "label": "Honorowe obywatelstwo gminy",
            "children": []
          },
          {
            "id": "052",
            "code": "052",
            "label": "Nadawanie odznaczeń, medali lub innych tytułów przez gminę",
            "children": []
          },
          {
            "id": "053",
            "code": "053",
            "label": "Kontakty ze środkami publicznego przekazu",
            "children": [
              {
                "id": "0530",
                "code": "0530",
                "label": "Informacje własne dla środków publicznego przekazu, odpowiedzi na informacje medialne",
                "children": []
              },
              {
                "id": "0531",
                "code": "0531",
                "label": "Konferencje prasowe i wywiady",
                "children": []
              },
              {
                "id": "0532",
                "code": "0532",
                "label": "Monitoring środków publicznego przekazu",
                "children": []
              }
            ]
          },
          {
            "id": "054",
            "code": "054",
            "label": "Promocja gminy w kraju i za granicą",
            "children": [
              {
                "id": "0540",
                "code": "0540",
                "label": "Strategie, programy i plany promocji gminy",
                "children": []
              },
              {
                "id": "0541",
                "code": "0541",
                "label": "Własne akcje promocyjne i reklamowe gminy",
                "children": []
              },
              {
                "id": "0542",
                "code": "0542",
                "label": "Udział w obcych wydarzeniach promocyjnych",
                "children": []
              },
              {
                "id": "0543",
                "code": "0543",
                "label": "Materiały promocyjne gminy i jej jednostek",
                "children": []
              },
              {
                "id": "0544",
                "code": "0544",
                "label": "Materiały do serwisu internetowego",
                "children": []
              }
            ]
          },
          {
            "id": "055",
            "code": "055",
            "label": "Własne wydawnictwa oraz udział w obcych wydawnictwach",
            "children": []
          },
          {
            "id": "056",
            "code": "056",
            "label": "Techniczne wykonanie materiałów promocyjnych i wydawnictw oraz ich rozpowszechnianie",
            "children": []
          },
          {
            "id": "057",
            "code": "057",
            "label": "Materiały fotograficzne lub audiowizualne z wydarzeń, akcji i imprez",
            "children": []
          },
          {
            "id": "058",
            "code": "058",
            "label": "Realizacja wniosków w programie \"Karta Krakowska\"",
            "children": []
          }
        ]
      },
      {
        "id": "06",
        "code": "06",
        "label": "Strategie, programy, planowanie, sprawozdawczość i analizy dotyczące działalności gminy oraz jej jednostek organizacyjnych",
        "children": [
          {
            "id": "060",
            "code": "060",
            "label": "Wyjaśnienia, interpretacje, opinie, akty prawne dotyczące strategii, programów, planowania, sprawozdawczości i analiz z działalności gminy oraz jej jednostek organizacyjnych",
            "children": []
          },
          {
            "id": "061",
            "code": "061",
            "label": "Strategie",
            "children": []
          },
          {
            "id": "062",
            "code": "062",
            "label": "Programy",
            "children": []
          },
          {
            "id": "063",
            "code": "063",
            "label": "Planowanie",
            "children": [
              {
                "id": "0630",
                "code": "0630",
                "label": "Planowanie na poziomie całej gminy",
                "children": []
              },
              {
                "id": "0631",
                "code": "0631",
                "label": "Planowanie na poziomie każdego urzędu lub jednostki organizacyjnej",
                "children": []
              },
              {
                "id": "0632",
                "code": "0632",
                "label": "Planowanie w komórkach organizacyjnych",
                "children": []
              }
            ]
          },
          {
            "id": "064",
            "code": "064",
            "label": "Sprawozdawczość",
            "children": [
              {
                "id": "0640",
                "code": "0640",
                "label": "Sprawozdawczość na poziomie całej gminy",
                "children": []
              },
              {
                "id": "0641",
                "code": "0641",
                "label": "Sprawozdawczość na poziomie każdego urzędu i jednostki organizacyjnej",
                "children": []
              },
              {
                "id": "0642",
                "code": "0642",
                "label": "Sprawozdawczość statystyczna",
                "children": []
              },
              {
                "id": "0643",
                "code": "0643",
                "label": "Sprawozdawczość z działalności komórek organizacyjnych",
                "children": []
              },
              {
                "id": "0644",
                "code": "0644",
                "label": "Meldunki i raporty sytuacyjne",
                "children": []
              }
            ]
          },
          {
            "id": "065",
            "code": "065",
            "label": "Analizy tematyczne lub przekrojowe, ankietyzacja",
            "children": []
          },
          {
            "id": "066",
            "code": "066",
            "label": "Informacje o charakterze analitycznym i sprawozdawczym dla innych podmiotów i jednostek organizacyjnych",
            "children": []
          }
        ]
      },
      {
        "id": "07",
        "code": "07",
        "label": "Legislacja, obsługa prawna gminy i jej jednostek organizacyjnych",
        "children": [
          {
            "id": "070",
            "code": "070",
            "label": "Wyjaśnienia, interpretacje, opinie, akty prawne dotyczące legislacji i obsługi prawnej",
            "children": []
          },
          {
            "id": "071",
            "code": "071",
            "label": "Akty prawa miejscowego",
            "children": [
              {
                "id": "0710",
                "code": "0710",
                "label": "Zbiór aktów prawa miejscowego",
                "children": []
              },
              {
                "id": "0711",
                "code": "0711",
                "label": "Przekazywanie aktów prawa miejscowego do ogłoszenia i badanie zgodności z prawem aktów prawa miejscowego",
                "children": []
              }
            ]
          },
          {
            "id": "072",
            "code": "072",
            "label": "Legislacja",
            "children": [
              {
                "id": "0720",
                "code": "0720",
                "label": "Własne działania legislacyjne w zakresie aktów prawnych powszechnie obowiązujących dotyczących samorządu terytorialnego",
                "children": []
              },
              {
                "id": "0721",
                "code": "0721",
                "label": "Opiniowanie przez gminę i jej jednostki organizacyjne projektów aktów prawa powszechnie obowiązującego",
                "children": []
              },
              {
                "id": "0722",
                "code": "0722",
                "label": "Opiniowanie przez gminę i jej jednostki organizacyjne projektów aktów prawa miejscowego",
                "children": []
              },
              {
                "id": "0723",
                "code": "0723",
                "label": "Opiniowanie przez gminę i jej jednostki organizacyjne innych projektów aktów prawa",
                "children": []
              },
              {
                "id": "0724",
                "code": "0724",
                "label": "Opiniowanie przez gminę i jej jednostki organizacyjne projektów dokumentów nie mających charakteru aktu prawnego",
                "children": []
              }
            ]
          },
          {
            "id": "073",
            "code": "073",
            "label": "Rozstrzyganie sporów kompetencyjnych między organami administracji publicznej",
            "children": []
          },
          {
            "id": "074",
            "code": "074",
            "label": "Opinie prawne na potrzeby gminy i jej jednostek organizacyjnych",
            "children": []
          },
          {
            "id": "075",
            "code": "075",
            "label": "Prowadzenie spraw sądowych",
            "children": [
              {
                "id": "0750",
                "code": "0750",
                "label": "Prowadzenie spraw sądowych przed sądami powszechnymi",
                "children": []
              },
              {
                "id": "0751",
                "code": "0751",
                "label": "Prowadzenie spraw sądowych przed sądami administracyjnymi",
                "children": []
              }
            ]
          },
          {
            "id": "076",
            "code": "076",
            "label": "Obsługa prawna w zakresie windykacji lub egzekucji należności",
            "children": []
          },
          {
            "id": "077",
            "code": "077",
            "label": "Pełnomocnictwa, upoważnienia, wzory podpisów, podpisy elektroniczne",
            "children": []
          }
        ]
      }
    ]
  },
  {
    "id": "1",
    "code": "1",
    "label": "ZARZĄDZANIE URZĘDAMI OBSŁUGUJĄCYMI ORGANY GMINY I ZWIĄZKI MIĘDZYGMINNE",
    "children": [
      {
        "id": "10",
        "code": "10",
        "label": "Udział w posiedzeniach organów kolegialnych gminy",
        "children": []
      },
      {
        "id": "11",
        "code": "11",
        "label": "Gremia kolegialne urzędu i udział przedstawicieli urzędu w obcych gremiach",
        "children": [
          {
            "id": "110",
            "code": "110",
            "label": "Posiedzenia kierownictwa urzędu",
            "children": []
          },
          {
            "id": "111",
            "code": "111",
            "label": "Komisje, zespoły, grupy robocze w urzędzie",
            "children": []
          },
          {
            "id": "112",
            "code": "112",
            "label": "Udział w obcych komisjach, zespołach, grupach roboczych",
            "children": []
          },
          {
            "id": "113",
            "code": "113",
            "label": "Narady (zebrania) pracowników",
            "children": []
          }
        ]
      },
      {
        "id": "12",
        "code": "12",
        "label": "Zbiory aktów normatywnych.",
        "children": [
          {
            "id": "120",
            "code": "120",
            "label": "Zbiory aktów normatywnych własnych kierownictw urzędów",
            "children": []
          },
          {
            "id": "121",
            "code": "121",
            "label": "Zbiory aktów normatywnych obcych",
            "children": []
          }
        ]
      },
      {
        "id": "13",
        "code": "13",
        "label": "Informatyzacja",
        "children": [
          {
            "id": "130",
            "code": "130",
            "label": "Wyjaśnienia, interpretacje, opinie, akty prawne dotyczące zagadnień z zakresu informatyzacji",
            "children": []
          },
          {
            "id": "131",
            "code": "131",
            "label": "Projektowanie, homologacje i wdrażanie oprogramowania i systemów teleinformatycznych",
            "children": []
          },
          {
            "id": "132",
            "code": "132",
            "label": "Licencje na oprogramowanie i systemy teleinformatyczne",
            "children": []
          },
          {
            "id": "133",
            "code": "133",
            "label": "Eksploatacja systemów teleinformatycznych i oprogramowania",
            "children": [
              {
                "id": "1330",
                "code": "1330",
                "label": "Organizacja prac eksploatacyjnych systemów teleinformatycznych i oprogramowania",
                "children": []
              },
              {
                "id": "1331",
                "code": "1331",
                "label": "Instrukcje eksploatacji systemów teleinformatycznych, systemów ewidencjonowania informacji, nośników i kopii bezpieczeństwa oraz archiwizowania oprogramowania i zbiorów danych",
                "children": []
              },
              {
                "id": "1332",
                "code": "1332",
                "label": "Ewidencja stosowanych systemów i programów",
                "children": []
              },
              {
                "id": "1333",
                "code": "1333",
                "label": "Użytkowanie i utrzymanie systemów oraz programów",
                "children": []
              },
              {
                "id": "1334",
                "code": "1334",
                "label": "Ustalanie uprawnień dostępu do danych i systemów",
                "children": []
              }
            ]
          },
          {
            "id": "134",
            "code": "134",
            "label": "Projektowanie i eksploatacja gminnych stron i portali internetowych",
            "children": []
          },
          {
            "id": "135",
            "code": "135",
            "label": "Bezpieczeństwo systemów teleinformatycznych",
            "children": []
          }
        ]
      },
      {
        "id": "14",
        "code": "14",
        "label": "Ochrona i udostępnianie informacji ustawowo chronionych oraz informacji publicznej",
        "children": [
          {
            "id": "140",
            "code": "140",
            "label": "Wyjaśnienia, interpretacje, opinie, akty prawne dotyczące zagadnień z zakresu ochrony i udostępniania informacji ustawowo chronionych oraz informacji publicznej",
            "children": []
          },
          {
            "id": "141",
            "code": "141",
            "label": "Informacje niejawne",
            "children": [
              {
                "id": "1410",
                "code": "1410",
                "label": "Organizacja systemu ochrony informacji niejawnych oraz wykazu tych informacji dla poszczególnych klauzul",
                "children": []
              },
              {
                "id": "1411",
                "code": "1411",
                "label": "Bieżące działania podejmowane w zakresie ochrony informacji niejawnych",
                "children": []
              },
              {
                "id": "1412",
                "code": "1412",
                "label": "Udostępnianie informacji niejawnych",
                "children": []
              }
            ]
          },
          {
            "id": "142",
            "code": "142",
            "label": "Ochrona danych osobowych",
            "children": []
          },
          {
            "id": "143",
            "code": "143",
            "label": "Informacja publiczna",
            "children": [
              {
                "id": "1430",
                "code": "1430",
                "label": "Obsługa merytoryczna Biuletynu Informacji Publicznej",
                "children": []
              },
              {
                "id": "1431",
                "code": "1431",
                "label": "Udostępnianie informacji publicznej",
                "children": []
              }
            ]
          },
          {
            "id": "144",
            "code": "144",
            "label": "Obsługa merytoryczna systemów powiadamiania mieszkańców gminy",
            "children": []
          }
        ]
      },
      {
        "id": "15",
        "code": "15",
        "label": "Skargi, wnioski, petycje oraz postulaty i inicjatywy obywateli",
        "children": [
          {
            "id": "150",
            "code": "150",
            "label": "Wyjaśnienia, interpretacje, opinie, akty prawne dotyczące zagadnień z zakresu skarg, wniosków, petycji oraz postulatów i inicjatyw obywateli",
            "children": []
          },
          {
            "id": "151",
            "code": "151",
            "label": "Skargi i wnioski",
            "children": [
              {
                "id": "1510",
                "code": "1510",
                "label": "Skargi i wnioski załatwiane bezpośrednio (w tym na jednostki podległe)",
                "children": []
              },
              {
                "id": "1511",
                "code": "1511",
                "label": "Skargi i wnioski przekazane do załatwienia według właściwości",
                "children": []
              }
            ]
          },
          {
            "id": "152",
            "code": "152",
            "label": "Petycje, postulaty i inicjatywy obywateli",
            "children": []
          },
          {
            "id": "153",
            "code": "153",
            "label": "Koordynacja działań związanych z uczestnictwem mieszkańców w życiu społecznym",
            "children": []
          }
        ]
      },
      {
        "id": "16",
        "code": "16",
        "label": "Obsługa kancelaryjna, archiwalna i biblioteczna",
        "children": [
          {
            "id": "160",
            "code": "160",
            "label": "Wyjaśnienia, interpretacje, opinie, akty prawne dotyczące zagadnień z zakresu obsługi kancelaryjnej, archiwalnej i bibliotecznej",
            "children": []
          },
          {
            "id": "161",
            "code": "161",
            "label": "Obsługa kancelaryjna",
            "children": [
              {
                "id": "1610",
                "code": "1610",
                "label": "Urządzenia do rejestracji i monitorowania obiegu przesyłek i pism",
                "children": []
              },
              {
                "id": "1611",
                "code": "1611",
                "label": "Opracowywanie lub wdrażanie wzorów formularzy oraz ich wykazy",
                "children": []
              },
              {
                "id": "1612",
                "code": "1612",
                "label": "Ewidencja druków ścisłego zarachowania",
                "children": []
              },
              {
                "id": "1613",
                "code": "1613",
                "label": "Ewidencja pieczęci i pieczątek oraz ich odcisków",
                "children": []
              },
              {
                "id": "1614",
                "code": "1614",
                "label": "Przekazywanie dokumentacji spraw niezakończonych między komórkami i jednostkami organizacyjnymi w związku ze zmianami organizacyjnymi",
                "children": []
              }
            ]
          },
          {
            "id": "162",
            "code": "162",
            "label": "Obsługa kancelaryjna dokumentacji zawierającej informacje niejawne",
            "children": [
              {
                "id": "1620",
                "code": "1620",
                "label": "Rejestr teczek (rejestr klas końcowych)",
                "children": []
              },
              {
                "id": "1621",
                "code": "1621",
                "label": "Dzienniki korespondencyjne dla dokumentacji o różnych klauzulach niejawności",
                "children": []
              },
              {
                "id": "1622",
                "code": "1622",
                "label": "Dziennik wykonanej dokumentacji",
                "children": []
              },
              {
                "id": "1623",
                "code": "1623",
                "label": "Przekazywanie dokumentacji spraw niezakończonych zawierającej informacje niejawne między komórkami i jednostkami organizacyjnymi w związku ze zmianami organizacyjnymi",
                "children": []
              }
            ]
          },
          {
            "id": "163",
            "code": "163",
            "label": "Archiwum zakładowe",
            "children": [
              {
                "id": "1630",
                "code": "1630",
                "label": "Ewidencja dokumentacji przechowywanej w archiwum zakładowym",
                "children": []
              },
              {
                "id": "1631",
                "code": "1631",
                "label": "Przekazywanie materiałów archiwalnych do archiwów państwowych",
                "children": []
              },
              {
                "id": "1632",
                "code": "1632",
                "label": "Brakowanie dokumentacji niearchiwalnej",
                "children": []
              },
              {
                "id": "1633",
                "code": "1633",
                "label": "Ewidencja udostępniania dokumentacji w archiwum zakładowym",
                "children": []
              },
              {
                "id": "1634",
                "code": "1634",
                "label": "Kwerendy archiwalne w dokumentacji w archiwum zakładowym",
                "children": []
              },
              {
                "id": "1635",
                "code": "1635",
                "label": "Skontrum dokumentacji w archiwum zakładowym",
                "children": []
              },
              {
                "id": "1636",
                "code": "1636",
                "label": "Profilaktyka i konserwacja dokumentacji w archiwum zakładowym",
                "children": []
              },
              {
                "id": "1637",
                "code": "1637",
                "label": "Doradzanie komórkom organizacyjnym w zakresie postępowania z dokumentacją oraz ustalanie terminów przejęcia dokumentacji",
                "children": []
              }
            ]
          },
          {
            "id": "164",
            "code": "164",
            "label": "Zbiory biblioteczne w podmiotach",
            "children": [
              {
                "id": "1640",
                "code": "1640",
                "label": "Ewidencja zbiorów bibliotecznych",
                "children": []
              },
              {
                "id": "1641",
                "code": "1641",
                "label": "Gromadzenie zbiorów bibliotecznych",
                "children": []
              },
              {
                "id": "1642",
                "code": "1642",
                "label": "Udostępnianie zbiorów bibliotecznych",
                "children": []
              }
            ]
          }
        ]
      },
      {
        "id": "17",
        "code": "17",
        "label": "Kontrola, audyt, szacowanie ryzyka dla realizacji zadań",
        "children": [
          {
            "id": "170",
            "code": "170",
            "label": "Wyjaśnienia, interpretacje, opinie, akty prawne dotyczące zagadnień z zakresu nadzoru, kontroli, audytu, szacowania ryzyka dla realizacji zadań",
            "children": []
          },
          {
            "id": "171",
            "code": "171",
            "label": "Kontrole",
            "children": [
              {
                "id": "1710",
                "code": "1710",
                "label": "Kontrole zewnętrzne w podmiotach",
                "children": []
              },
              {
                "id": "1711",
                "code": "1711",
                "label": "Kontrole przeprowadzane przez podmioty w jednostkach im podległych",
                "children": []
              },
              {
                "id": "1712",
                "code": "1712",
                "label": "Kontrole wewnętrzne w podmiocie",
                "children": []
              },
              {
                "id": "1713",
                "code": "1713",
                "label": "Udział podmiotów w kontrolach przeprowadzonych przez inne organy lub jednostki organizacyjne",
                "children": []
              },
              {
                "id": "1714",
                "code": "1714",
                "label": "Książka kontroli",
                "children": []
              }
            ]
          },
          {
            "id": "172",
            "code": "172",
            "label": "Audyt",
            "children": [
              {
                "id": "1720",
                "code": "1720",
                "label": "Bieżące akta audytu",
                "children": []
              },
              {
                "id": "1721",
                "code": "1721",
                "label": "Stałe akta audytu",
                "children": []
              }
            ]
          },
          {
            "id": "173",
            "code": "173",
            "label": "Szacowanie ryzyka dla realizacji zadań",
            "children": []
          }
        ]
      }
    ]
  },
  {
    "id": "2",
    "code": "2",
    "label": "SPRAWY KADROWE I ADMINISTRACYJNE PROWADZONE PRZEZ GMINĘ I JEJ JEDNOSTKI ORGANIZACYJNE",
    "children": [
      {
        "id": "20",
        "code": "20",
        "label": "Regulacje oraz wyjaśnienia, interpretacje, opinie, akty prawne dotyczące zagadnień z zakresu spraw kadrowych i administracyjnych",
        "children": [
          {
            "id": "200",
            "code": "200",
            "label": "Regulacje oraz wyjaśnienia, interpretacje, opinie, akty prawne dotyczące zagadnień z zakresu spraw kadrowych",
            "children": [
              {
                "id": "2000",
                "code": "2000",
                "label": "Własne regulacje, ich projekty oraz wyjaśnienia, interpretacje, opinie w sprawach kadrowych",
                "children": []
              },
              {
                "id": "2001",
                "code": "2001",
                "label": "Otrzymane od organów i jednostek zewnętrznych regulacje, wyjaśnienia, interpretacje, opinie, akty prawne dotyczące zagadnień z zakresu spraw kadrowych",
                "children": []
              },
              {
                "id": "2002",
                "code": "2002",
                "label": "Wykazy etatów",
                "children": []
              },
              {
                "id": "2003",
                "code": "2003",
                "label": "Opisy stanowisk pracy i określanie zakresu kompetencji i zadań",
                "children": []
              },
              {
                "id": "2004",
                "code": "2004",
                "label": "Umowy zbiorowe i ich negocjowanie",
                "children": []
              }
            ]
          },
          {
            "id": "201",
            "code": "201",
            "label": "Regulacje oraz wyjaśnienia, interpretacje, opinie, akty prawne dotyczące zagadnień z zakresu spraw administracyjnych",
            "children": [
              {
                "id": "2010",
                "code": "2010",
                "label": "Własne regulacje, ich projekty oraz wyjaśnienia, interpretacje, opinie w sprawach administracyjnych",
                "children": []
              },
              {
                "id": "2011",
                "code": "2011",
                "label": "Otrzymane od organów i jednostek zewnętrznych regulacje, wyjaśnienia, interpretacje, opinie, akty prawne dotyczące zagadnień z zakresu spraw administracyjnych",
                "children": []
              }
            ]
          }
        ]
      },
      {
        "id": "21",
        "code": "21",
        "label": "Nawiązywanie, przebieg i rozwiązywanie stosunku pracy oraz innych form zatrudnienia w imieniu organów gminy i kierowników podmiotów",
        "children": [
          {
            "id": "210",
            "code": "210",
            "label": "Zapotrzebowanie i nabór kandydatów do pracy",
            "children": []
          },
          {
            "id": "211",
            "code": "211",
            "label": "Konkursy na stanowiska",
            "children": [
              {
                "id": "2110",
                "code": "2110",
                "label": "Konkursy na stanowiska w urzędach",
                "children": []
              },
              {
                "id": "2111",
                "code": "2111",
                "label": "Konkursy na stanowiska w jednostkach podległych",
                "children": []
              }
            ]
          },
          {
            "id": "212",
            "code": "212",
            "label": "Obsługa zatrudnienia",
            "children": [
              {
                "id": "2120",
                "code": "2120",
                "label": "Obsługa zatrudnienia kierownictw urzędów oraz kierownictw jednostek podległych",
                "children": []
              },
              {
                "id": "2121",
                "code": "2121",
                "label": "Obsługa zatrudnienia pracowników urzędów",
                "children": []
              },
              {
                "id": "2122",
                "code": "2122",
                "label": "Rozmieszczanie i wynagradzanie pracowników urzędów",
                "children": []
              },
              {
                "id": "2123",
                "code": "2123",
                "label": "Rozmieszczanie i wynagradzanie kierownictw jednostek podległych",
                "children": []
              },
              {
                "id": "2124",
                "code": "2124",
                "label": "Oświadczenia majątkowe lub inne oświadczenia o osobach zatrudnionych i członkach ich rodzin",
                "children": []
              }
            ]
          },
          {
            "id": "213",
            "code": "213",
            "label": "Opiniowanie i ocenianie osób zatrudnionych",
            "children": [
              {
                "id": "2130",
                "code": "2130",
                "label": "Opiniowanie i ocenianie pracowników urzędów",
                "children": []
              },
              {
                "id": "2131",
                "code": "2131",
                "label": "Opiniowanie i ocenianie kierownictw jednostek podległych",
                "children": []
              }
            ]
          },
          {
            "id": "214",
            "code": "214",
            "label": "Staże, wolontariat, praktyki",
            "children": [
              {
                "id": "2140",
                "code": "2140",
                "label": "Staże zawodowe",
                "children": []
              },
              {
                "id": "2141",
                "code": "2141",
                "label": "Wolontariat",
                "children": []
              },
              {
                "id": "2142",
                "code": "2142",
                "label": "Praktyki",
                "children": []
              }
            ]
          },
          {
            "id": "215",
            "code": "215",
            "label": "Prace zlecone (umowy cywilno-prawne)",
            "children": [
              {
                "id": "2150",
                "code": "2150",
                "label": "Prace zlecone ze składką na ubezpieczenie społeczne",
                "children": []
              },
              {
                "id": "2151",
                "code": "2151",
                "label": "Prace zlecone bez składki na ubezpieczenie społeczne",
                "children": []
              }
            ]
          },
          {
            "id": "216",
            "code": "216",
            "label": "Nagradzanie, odznaczanie i karanie",
            "children": [
              {
                "id": "2160",
                "code": "2160",
                "label": "Nagrody, podziękowania, listy gratulacyjne",
                "children": []
              },
              {
                "id": "2161",
                "code": "2161",
                "label": "Odznaczenia państwowe, samorządowe i inne",
                "children": []
              },
              {
                "id": "2162",
                "code": "2162",
                "label": "Karanie",
                "children": []
              },
              {
                "id": "2163",
                "code": "2163",
                "label": "Postępowanie dyscyplinarne",
                "children": []
              }
            ]
          },
          {
            "id": "217",
            "code": "217",
            "label": "Sprawy wojskowe osób zatrudnionych",
            "children": []
          },
          {
            "id": "218",
            "code": "218",
            "label": "Dostęp osób zatrudnionych do informacji chronionych przepisami prawa",
            "children": []
          }
        ]
      },
      {
        "id": "22",
        "code": "22",
        "label": "Ewidencja osobowa",
        "children": [
          {
            "id": "220",
            "code": "220",
            "label": "Akta osobowe osób zatrudnionych",
            "children": []
          },
          {
            "id": "221",
            "code": "221",
            "label": "Pomoce ewidencyjne do akt osobowych",
            "children": []
          },
          {
            "id": "222",
            "code": "222",
            "label": "Pomocnicza dokumentacja osobowa w komórkach organizacyjnych",
            "children": []
          },
          {
            "id": "223",
            "code": "223",
            "label": "Legitymacje służbowe",
            "children": []
          },
          {
            "id": "224",
            "code": "224",
            "label": "Zaświadczenia o zatrudnieniu i wynagrodzeniu",
            "children": []
          }
        ]
      },
      {
        "id": "23",
        "code": "23",
        "label": "Bezpieczeństwo i higiena pracy oraz dyscyplina pracy",
        "children": [
          {
            "id": "230",
            "code": "230",
            "label": "Przeglądy warunków i bezpieczeństwa pracy",
            "children": []
          },
          {
            "id": "231",
            "code": "231",
            "label": "Działania w zakresie zwalczania wypadków, chorób zawodowych, ryzyka w pracy",
            "children": []
          },
          {
            "id": "232",
            "code": "232",
            "label": "Wypadki",
            "children": [
              {
                "id": "2320",
                "code": "2320",
                "label": "Wypadki przy pracy",
                "children": []
              },
              {
                "id": "2321",
                "code": "2321",
                "label": "Wypadki w drodze do pracy i z pracy",
                "children": []
              }
            ]
          },
          {
            "id": "233",
            "code": "233",
            "label": "Warunki szkodliwe i choroby zawodowe",
            "children": [
              {
                "id": "2330",
                "code": "2330",
                "label": "Warunki szkodliwe",
                "children": []
              },
              {
                "id": "2331",
                "code": "2331",
                "label": "Rejestr warunków szkodliwych",
                "children": []
              },
              {
                "id": "2332",
                "code": "2332",
                "label": "Choroby zawodowe",
                "children": []
              }
            ]
          },
          {
            "id": "234",
            "code": "234",
            "label": "Czas pracy",
            "children": [
              {
                "id": "2340",
                "code": "2340",
                "label": "Dowody obecności w pracy",
                "children": []
              },
              {
                "id": "2341",
                "code": "2341",
                "label": "Absencje w pracy",
                "children": []
              },
              {
                "id": "2342",
                "code": "2342",
                "label": "Rozliczenia czasu pracy",
                "children": []
              },
              {
                "id": "2343",
                "code": "2343",
                "label": "Delegacje służbowe",
                "children": []
              },
              {
                "id": "2344",
                "code": "2344",
                "label": "Ustalanie i zmiany czasu pracy",
                "children": []
              }
            ]
          },
          {
            "id": "235",
            "code": "235",
            "label": "Urlopy osób zatrudnionych",
            "children": [
              {
                "id": "2350",
                "code": "2350",
                "label": "Urlopy wypoczynkowe",
                "children": []
              },
              {
                "id": "2351",
                "code": "2351",
                "label": "Urlopy macierzyńskie, ojcowskie i wychowawcze itp.",
                "children": []
              },
              {
                "id": "2352",
                "code": "2352",
                "label": "Urlopy bezpłatne",
                "children": []
              }
            ]
          },
          {
            "id": "236",
            "code": "236",
            "label": "Dodatkowe zatrudnienie osób zatrudnionych oraz umowy o zakazie konkurencji",
            "children": []
          }
        ]
      },
      {
        "id": "24",
        "code": "24",
        "label": "Szkolenie i doskonalenie zawodowe osób zatrudnionych, sprawy socjalno-bytowe oraz ubezpieczenia społeczne i opieka zdrowotna",
        "children": [
          {
            "id": "240",
            "code": "240",
            "label": "Szkolenie i doskonalenie zawodowe osób zatrudnionych",
            "children": [
              {
                "id": "2400",
                "code": "2400",
                "label": "Ustalanie ścieżek rozwoju zawodowego dla osób zatrudnionych",
                "children": []
              },
              {
                "id": "2401",
                "code": "2401",
                "label": "Służba przygotowawcza",
                "children": []
              },
              {
                "id": "2402",
                "code": "2402",
                "label": "Szkolenia organizowane we własnym zakresie dla osób zatrudnionych w podmiotach",
                "children": []
              },
              {
                "id": "2403",
                "code": "2403",
                "label": "Dokształcanie pracowników",
                "children": []
              }
            ]
          },
          {
            "id": "241",
            "code": "241",
            "label": "Sprawy socjalno-bytowe",
            "children": [
              {
                "id": "2410",
                "code": "2410",
                "label": "Sprawy socjalno-bytowe załatwiane w ramach zakładowego funduszu świadczeń socjalnych",
                "children": []
              },
              {
                "id": "2411",
                "code": "2411",
                "label": "Zaopatrzenie rzeczowe osób zatrudnionych",
                "children": []
              },
              {
                "id": "2412",
                "code": "2412",
                "label": "Opieka nad emerytami, rencistami i osobami niepełnosprawnymi",
                "children": []
              },
              {
                "id": "2413",
                "code": "2413",
                "label": "Akcje socjalne i imprezy kulturalne poza zakładowym funduszem świadczeń socjalnych",
                "children": []
              },
              {
                "id": "2414",
                "code": "2414",
                "label": "Wspieranie osób zatrudnionych w zakresie zaspokajania potrzeb mieszkaniowych i ulg na przejazdy",
                "children": []
              }
            ]
          },
          {
            "id": "242",
            "code": "242",
            "label": "Ubezpieczenia społeczne",
            "children": [
              {
                "id": "2420",
                "code": "2420",
                "label": "Zgłoszenia do ubezpieczenia społecznego",
                "children": []
              },
              {
                "id": "2421",
                "code": "2421",
                "label": "Obsługa ubezpieczenia społecznego",
                "children": []
              },
              {
                "id": "2422",
                "code": "2422",
                "label": "Legitymacje ubezpieczeniowe",
                "children": []
              },
              {
                "id": "2423",
                "code": "2423",
                "label": "Dowody uprawnień do zasiłków",
                "children": []
              },
              {
                "id": "2424",
                "code": "2424",
                "label": "Emerytury i renty",
                "children": []
              },
              {
                "id": "2425",
                "code": "2425",
                "label": "Ubezpieczenia zbiorowe, pracownicze, itp.",
                "children": []
              },
              {
                "id": "2426",
                "code": "2426",
                "label": "Zarządzanie Pracowniczym Planem Kapitałowym",
                "children": []
              }
            ]
          },
          {
            "id": "243",
            "code": "243",
            "label": "Opieka zdrowotna",
            "children": [
              {
                "id": "2430",
                "code": "2430",
                "label": "Organizowanie i obsługa opieki zdrowotnej",
                "children": []
              },
              {
                "id": "2431",
                "code": "2431",
                "label": "Badania lekarskie w zakresie medycyny pracy",
                "children": []
              }
            ]
          }
        ]
      },
      {
        "id": "25",
        "code": "25",
        "label": "Administrowanie i eksploatowanie obiektów będących w dyspozycji urzędów i innych jednostek organizacyjnych gminy",
        "children": [
          {
            "id": "250",
            "code": "250",
            "label": "Administracja obiektami",
            "children": [
              {
                "id": "2500",
                "code": "2500",
                "label": "Przejmowanie obiektów na potrzeby urzędów i jednostek organizacyjnych gminy",
                "children": []
              },
              {
                "id": "2501",
                "code": "2501",
                "label": "Udostępnianie i oddawanie w najem lub w dzierżawę własnych obiektów i lokali innym jednostkom i osobom",
                "children": []
              },
              {
                "id": "2502",
                "code": "2502",
                "label": "Najmowanie lokali od innych na potrzeby własne",
                "children": []
              }
            ]
          },
          {
            "id": "251",
            "code": "251",
            "label": "Eksploatacja budynków i lokali przez urzędy i jednostki organizacyjne gminy",
            "children": [
              {
                "id": "2510",
                "code": "2510",
                "label": "Przygotowanie i realizacja remontów bieżących budynków, lokali i pomieszczeń",
                "children": []
              },
              {
                "id": "2511",
                "code": "2511",
                "label": "Dokumentacja techniczna prac remontowych",
                "children": []
              },
              {
                "id": "2512",
                "code": "2512",
                "label": "Konserwacja i eksploatacja bieżąca budynków, lokali i pomieszczeń",
                "children": []
              }
            ]
          },
          {
            "id": "252",
            "code": "252",
            "label": "Podatki i opłaty publiczne",
            "children": []
          },
          {
            "id": "253",
            "code": "253",
            "label": "Ubezpieczenia majątkowe",
            "children": []
          },
          {
            "id": "254",
            "code": "254",
            "label": "Ochrona mienia własnej jednostki",
            "children": []
          },
          {
            "id": "255",
            "code": "255",
            "label": "Ochrona przeciwpożarowa",
            "children": []
          }
        ]
      },
      {
        "id": "26",
        "code": "26",
        "label": "Gospodarka materiałowa",
        "children": [
          {
            "id": "260",
            "code": "260",
            "label": "Zaopatrzenie",
            "children": [
              {
                "id": "2600",
                "code": "2600",
                "label": "Źródła zaopatrzenia",
                "children": []
              },
              {
                "id": "2601",
                "code": "2601",
                "label": "Zaopatrzenie materiałowe",
                "children": []
              }
            ]
          },
          {
            "id": "261",
            "code": "261",
            "label": "Obsługa materiałowa środków rzeczowych",
            "children": [
              {
                "id": "2610",
                "code": "2610",
                "label": "Magazynowanie środków trwałych i nietrwałych",
                "children": []
              },
              {
                "id": "2611",
                "code": "2611",
                "label": "Ewidencja środków trwałych i nietrwałych",
                "children": []
              },
              {
                "id": "2612",
                "code": "2612",
                "label": "Ewidencja osobistego wyposażenia pracowników",
                "children": []
              },
              {
                "id": "2613",
                "code": "2613",
                "label": "Eksploatacja i likwidacja środków trwałych i przedmiotów nietrwałych",
                "children": []
              },
              {
                "id": "2614",
                "code": "2614",
                "label": "Konserwacja i remonty środków trwałych",
                "children": []
              },
              {
                "id": "2615",
                "code": "2615",
                "label": "Dokumentacja techniczno-eksploatacyjna środków trwałych",
                "children": []
              }
            ]
          },
          {
            "id": "262",
            "code": "262",
            "label": "Gospodarka odpadami (surowcami wtórnymi)",
            "children": []
          },
          {
            "id": "263",
            "code": "263",
            "label": "Transport, łączność, infrastruktura informatyczna i telekomunikacyjna",
            "children": [
              {
                "id": "2630",
                "code": "2630",
                "label": "Zakupy środków i usług transportowych, łączności, pocztowych i kurierskich",
                "children": []
              },
              {
                "id": "2631",
                "code": "2631",
                "label": "Ewidencja środków transportu",
                "children": []
              },
              {
                "id": "2632",
                "code": "2632",
                "label": "Eksploatacja własnych środków transportowych",
                "children": []
              },
              {
                "id": "2633",
                "code": "2633",
                "label": "Użytkowanie obcych środków transportowych",
                "children": []
              },
              {
                "id": "2634",
                "code": "2634",
                "label": "Eksploatacja środków łączności (telefonów, telefaksów, modemów, łączy internetowych)",
                "children": []
              },
              {
                "id": "2635",
                "code": "2635",
                "label": "Organizacja i eksploatacja infrastruktury informatycznej i telekomunikacyjnej",
                "children": []
              }
            ]
          }
        ]
      },
      {
        "id": "27",
        "code": "27",
        "label": "Zamówienia publiczne",
        "children": [
          {
            "id": "270",
            "code": "270",
            "label": "Wyjaśnienia, interpretacje, opinie, akty prawne dotyczące zagadnień z zakresu zamówień publicznych",
            "children": []
          },
          {
            "id": "271",
            "code": "271",
            "label": "Dokumentacja zamówień publicznych",
            "children": []
          },
          {
            "id": "272",
            "code": "272",
            "label": "Umowy zawarte w wyniku postępowania w trybie zamówień publicznych",
            "children": []
          }
        ]
      }
    ]
  },
  {
    "id": "3",
    "code": "3",
    "label": "FINANSE GMINY ORAZ OBSŁUGA FINANSOWO-KSIĘGOWA URZĘDÓW I JEDNOSTEK ORGANIZACYJNYCH GMINY",
    "children": [
      {
        "id": "30",
        "code": "30",
        "label": "Planowanie i realizacja budżetu",
        "children": [
          {
            "id": "300",
            "code": "300",
            "label": "Wyjaśnienia, interpretacje, opinie, akty prawne dotyczące zagadnień z zakresu planowania i realizacji budżetu",
            "children": []
          },
          {
            "id": "301",
            "code": "301",
            "label": "Wieloletnia prognoza finansowa",
            "children": []
          },
          {
            "id": "302",
            "code": "302",
            "label": "Planowanie budżetu gminy",
            "children": [
              {
                "id": "3020",
                "code": "3020",
                "label": "Przygotowanie projektu budżetu gminy",
                "children": []
              },
              {
                "id": "3021",
                "code": "3021",
                "label": "Budżet gminy i jego zmiany",
                "children": []
              },
              {
                "id": "3022",
                "code": "3022",
                "label": "Opiniowanie budżetu przez Regionalną Izbę Obrachunkową",
                "children": []
              },
              {
                "id": "3023",
                "code": "3023",
                "label": "Informacja o stanie mienia komunalnego",
                "children": []
              },
              {
                "id": "3024",
                "code": "3024",
                "label": "Analizowanie i weryfikowanie planów finansowych dysponentów budżetu",
                "children": []
              },
              {
                "id": "3025",
                "code": "3025",
                "label": "Propozycje organów jednostek pomocniczych gminy dotyczące rozdysponowania środków budżetowych",
                "children": []
              },
              {
                "id": "3026",
                "code": "3026",
                "label": "Budżety komórek organizacyjnych i ich zmiany",
                "children": []
              },
              {
                "id": "3027",
                "code": "3027",
                "label": "Budżet obywatelski",
                "children": []
              }
            ]
          },
          {
            "id": "303",
            "code": "303",
            "label": "Realizacja budżetu",
            "children": [
              {
                "id": "3030",
                "code": "3030",
                "label": "Układ wykonawczy budżetu gminy",
                "children": []
              },
              {
                "id": "3031",
                "code": "3031",
                "label": "Przekazywanie środków finansowych dla urzędów, ich komórek i jednostek organizacyjnych gminy",
                "children": []
              },
              {
                "id": "3032",
                "code": "3032",
                "label": "Rozliczanie dochodów, wydatków, subwencji i dotacji",
                "children": []
              },
              {
                "id": "3033",
                "code": "3033",
                "label": "Ewidencjonowanie dochodów, wykorzystania środków, dotacji i subwencji",
                "children": []
              },
              {
                "id": "3034",
                "code": "3034",
                "label": "Sprawozdania okresowe z wykonania budżetu",
                "children": []
              },
              {
                "id": "3035",
                "code": "3035",
                "label": "Sprawozdanie roczne, bilans i analizy z wykonania budżetu",
                "children": []
              },
              {
                "id": "3036",
                "code": "3036",
                "label": "Rewizja budżetu i jego bilansu",
                "children": []
              },
              {
                "id": "3037",
                "code": "3037",
                "label": "Realizacja budżetów komórek organizacyjnych",
                "children": []
              }
            ]
          },
          {
            "id": "304",
            "code": "304",
            "label": "Finansowanie",
            "children": [
              {
                "id": "3040",
                "code": "3040",
                "label": "Finansowanie działalności urzędów i jednostek organizacyjnych gminy",
                "children": []
              },
              {
                "id": "3041",
                "code": "3041",
                "label": "Finansowanie inwestycji",
                "children": []
              },
              {
                "id": "3042",
                "code": "3042",
                "label": "Finansowanie remontów",
                "children": []
              }
            ]
          },
          {
            "id": "305",
            "code": "305",
            "label": "Obsługa finansowa funduszy, środków dodatkowych, pożyczek, kredytów, dochodów pozabudżetowych",
            "children": [
              {
                "id": "3050",
                "code": "3050",
                "label": "Obsługa finansowa funduszy i środków dodatkowych",
                "children": []
              },
              {
                "id": "3051",
                "code": "3051",
                "label": "Obsługa finansowa pożyczek i kredytów",
                "children": []
              },
              {
                "id": "3052",
                "code": "3052",
                "label": "Współpraca z bankami finansującymi i kredytującymi",
                "children": []
              },
              {
                "id": "3053",
                "code": "3053",
                "label": "Obsługa finansowa funduszy ze środków zagranicznych, w tym Unii Europejskiej",
                "children": []
              },
              {
                "id": "3054",
                "code": "3054",
                "label": "Gospodarka pozabudżetowa",
                "children": []
              }
            ]
          },
          {
            "id": "306",
            "code": "306",
            "label": "Emitowanie obligacji",
            "children": [
              {
                "id": "3060",
                "code": "3060",
                "label": "Emitowanie obligacji na terenie kraju",
                "children": []
              },
              {
                "id": "3061",
                "code": "3061",
                "label": "Emitowanie obligacji za granicą",
                "children": []
              }
            ]
          }
        ]
      },
      {
        "id": "31",
        "code": "31",
        "label": "Dochody, podatki i opłaty",
        "children": [
          {
            "id": "310",
            "code": "310",
            "label": "Wyjaśnienia, interpretacje, opinie, akty prawne dotyczące zagadnień z zakresu dochodów, podatków, opłat, egzekucji i windykacji",
            "children": []
          },
          {
            "id": "311",
            "code": "311",
            "label": "Zobowiązania podatkowe",
            "children": [
              {
                "id": "3110",
                "code": "3110",
                "label": "Planowanie dochodów z podatków i opłat oraz sprawozdawczość w tym zakresie",
                "children": []
              },
              {
                "id": "3111",
                "code": "3111",
                "label": "Rejestry podatkowe, ewidencje i wykazy w tym zakresie",
                "children": []
              }
            ]
          },
          {
            "id": "312",
            "code": "312",
            "label": "Podatki i ich wymiary",
            "children": [
              {
                "id": "3120",
                "code": "3120",
                "label": "Podatek od nieruchomości",
                "children": []
              },
              {
                "id": "3121",
                "code": "3121",
                "label": "Podatek rolny",
                "children": []
              },
              {
                "id": "3122",
                "code": "3122",
                "label": "Podatek leśny",
                "children": []
              },
              {
                "id": "3123",
                "code": "3123",
                "label": "Łączne zobowiązanie podatkowe rolników",
                "children": []
              },
              {
                "id": "3124",
                "code": "3124",
                "label": "Podatek od środków transportowych",
                "children": []
              },
              {
                "id": "3125",
                "code": "3125",
                "label": "Podatek od osób fizycznych",
                "children": []
              },
              {
                "id": "3126",
                "code": "3126",
                "label": "Podatek od spadków i darowizn",
                "children": []
              },
              {
                "id": "3127",
                "code": "3127",
                "label": "Łączne zobowiązanie podatkowe dla osób nie będących rolnikami",
                "children": []
              }
            ]
          },
          {
            "id": "313",
            "code": "313",
            "label": "Opłaty",
            "children": [
              {
                "id": "3130",
                "code": "3130",
                "label": "Opłata skarbowa",
                "children": []
              },
              {
                "id": "3131",
                "code": "3131",
                "label": "Opłata eksploatacyjna",
                "children": []
              },
              {
                "id": "3132",
                "code": "3132",
                "label": "Opłata targowa",
                "children": []
              },
              {
                "id": "3133",
                "code": "3133",
                "label": "Opłata ewidencyjna CEPiK",
                "children": []
              },
              {
                "id": "3134",
                "code": "3134",
                "label": "Opłata adiacencka",
                "children": []
              },
              {
                "id": "3135",
                "code": "3135",
                "label": "Opłata miejscowa",
                "children": []
              },
              {
                "id": "3136",
                "code": "3136",
                "label": "Opłaty za zarząd gruntami i za ich użytkowanie",
                "children": []
              },
              {
                "id": "3137",
                "code": "3137",
                "label": "Opłata administracyjna",
                "children": []
              },
              {
                "id": "3138",
                "code": "3138",
                "label": "Opłata od posiadania psów",
                "children": []
              },
              {
                "id": "3139",
                "code": "3139",
                "label": "Opłata za gospodarowanie odpadami komunalnymi",
                "children": []
              }
            ]
          },
          {
            "id": "314",
            "code": "314",
            "label": "Zaświadczenia",
            "children": [
              {
                "id": "3140",
                "code": "3140",
                "label": "Zaświadczenia w sprawach podatkowych",
                "children": []
              },
              {
                "id": "3141",
                "code": "3141",
                "label": "Zaświadczenia w sprawach opłat",
                "children": []
              }
            ]
          },
          {
            "id": "315",
            "code": "315",
            "label": "Inne dochody gminy",
            "children": [
              {
                "id": "3150",
                "code": "3150",
                "label": "Dochody z majątku gminy",
                "children": []
              },
              {
                "id": "3151",
                "code": "3151",
                "label": "Odsetki",
                "children": []
              },
              {
                "id": "3152",
                "code": "3152",
                "label": "Dochody z majątku Skarbu Państwa",
                "children": []
              },
              {
                "id": "3153",
                "code": "3153",
                "label": "Dotacje",
                "children": []
              },
              {
                "id": "3154",
                "code": "3154",
                "label": "Subwencje",
                "children": []
              }
            ]
          },
          {
            "id": "316",
            "code": "316",
            "label": "Egzekucja i windykacja",
            "children": [
              {
                "id": "3160",
                "code": "3160",
                "label": "Egzekucja administracyjna prowadzona przez podmiot",
                "children": []
              },
              {
                "id": "3161",
                "code": "3161",
                "label": "Egzekucja administracyjna prowadzona przez inne organy egzekucyjne",
                "children": []
              },
              {
                "id": "3162",
                "code": "3162",
                "label": "Windykacja należności",
                "children": []
              },
              {
                "id": "3163",
                "code": "3163",
                "label": "Kontrole podatkowe przeprowadzane przez przedstawicieli gminy u podatników",
                "children": []
              }
            ]
          },
          {
            "id": "317",
            "code": "317",
            "label": "Opłaty i inkaso sołtysów",
            "children": []
          }
        ]
      },
      {
        "id": "32",
        "code": "32",
        "label": "Rachunkowość, księgowość, obsługa kasowa",
        "children": [
          {
            "id": "320",
            "code": "320",
            "label": "Wyjaśnienia, interpretacje, opinie, akty prawne dotyczące zagadnień z zakresu rachunkowości, księgowości i obsługi kasowej",
            "children": [
              {
                "id": "3200",
                "code": "3200",
                "label": "Polityka rachunkowości i plany kont",
                "children": []
              },
              {
                "id": "3201",
                "code": "3201",
                "label": "Wyjaśnienia, interpretacje, opinie dotyczące zagadnień z zakresu rachunkowości, księgowości i obsługi kasowej",
                "children": []
              }
            ]
          },
          {
            "id": "321",
            "code": "321",
            "label": "Obrót gotówkowy i bezgotówkowy",
            "children": [
              {
                "id": "3210",
                "code": "3210",
                "label": "Obrót gotówkowy",
                "children": []
              },
              {
                "id": "3211",
                "code": "3211",
                "label": "Obrót bezgotówkowy",
                "children": []
              },
              {
                "id": "3212",
                "code": "3212",
                "label": "Depozyty kasowe, obsługa wadium",
                "children": []
              }
            ]
          },
          {
            "id": "322",
            "code": "322",
            "label": "Księgowość",
            "children": [
              {
                "id": "3220",
                "code": "3220",
                "label": "Dowody księgowe",
                "children": []
              },
              {
                "id": "3221",
                "code": "3221",
                "label": "Dokumentacja księgowa",
                "children": []
              },
              {
                "id": "3222",
                "code": "3222",
                "label": "Rozliczenia",
                "children": []
              },
              {
                "id": "3223",
                "code": "3223",
                "label": "Ewidencja syntetyczna i analityczna",
                "children": []
              },
              {
                "id": "3224",
                "code": "3224",
                "label": "Uzgadnianie sald",
                "children": []
              },
              {
                "id": "3225",
                "code": "3225",
                "label": "Kontrole i rewizje kasy",
                "children": []
              },
              {
                "id": "3226",
                "code": "3226",
                "label": "Zobowiązania, poręczenia",
                "children": []
              },
              {
                "id": "3227",
                "code": "3227",
                "label": "Księgowość materiałowo-towarowa",
                "children": []
              },
              {
                "id": "3228",
                "code": "3228",
                "label": "Obsługa księgowa w zakresie VAT",
                "children": []
              }
            ]
          },
          {
            "id": "323",
            "code": "323",
            "label": "Rozliczenia płac i wynagrodzeń",
            "children": [
              {
                "id": "3230",
                "code": "3230",
                "label": "Dokumentacja płac i potrąceń z płac",
                "children": []
              },
              {
                "id": "3231",
                "code": "3231",
                "label": "Listy płac",
                "children": []
              },
              {
                "id": "3232",
                "code": "3232",
                "label": "Kartoteki wynagrodzeń",
                "children": []
              },
              {
                "id": "3233",
                "code": "3233",
                "label": "Wypłaty diet radnym",
                "children": []
              },
              {
                "id": "3234",
                "code": "3234",
                "label": "Deklaracje podatkowe i rozliczenia podatku dochodowego",
                "children": []
              },
              {
                "id": "3235",
                "code": "3235",
                "label": "Rozliczenia składek na ubezpieczenie społeczne",
                "children": []
              },
              {
                "id": "3236",
                "code": "3236",
                "label": "Deklaracje na PFRON",
                "children": []
              },
              {
                "id": "3237",
                "code": "3237",
                "label": "Dokumentacja wynagrodzeń z bezosobowego funduszu płac",
                "children": []
              }
            ]
          },
          {
            "id": "324",
            "code": "324",
            "label": "Inwentaryzacja",
            "children": [
              {
                "id": "3240",
                "code": "3240",
                "label": "Wycena i przecena",
                "children": []
              },
              {
                "id": "3241",
                "code": "3241",
                "label": "Spisy i protokoły inwentaryzacyjne, sprawozdania z przebiegu inwentaryzacji i różnice inwentaryzacyjne",
                "children": []
              }
            ]
          },
          {
            "id": "325",
            "code": "325",
            "label": "Dyscyplina finansowa",
            "children": [
              {
                "id": "3250",
                "code": "3250",
                "label": "Interwencje Głównego Księgowego",
                "children": []
              },
              {
                "id": "3251",
                "code": "3251",
                "label": "Inne sprawy nadzoru finansowego",
                "children": []
              }
            ]
          }
        ]
      }
    ]
  },
  {
    "id": "4",
    "code": "4",
    "label": "KULTURA, OCHRONA ZABYTKÓW, KULTURA FIZYCZNA, TURYSTYKA I WYPOCZYNEK ORAZ SYSTEM OŚWIATY",
    "children": [
      {
        "id": "40",
        "code": "40",
        "label": "Kultura",
        "children": [
          {
            "id": "400",
            "code": "400",
            "label": "Wyjaśnienia, interpretacje, opinie, akty prawne dotyczące zagadnień z zakresu kultury",
            "children": []
          },
          {
            "id": "401",
            "code": "401",
            "label": "Programy rozwoju kultury i ochrony dziedzictwa kulturowego",
            "children": []
          },
          {
            "id": "402",
            "code": "402",
            "label": "Rejestracja instytucji kultury i monitorowanie ich działalności",
            "children": []
          },
          {
            "id": "403",
            "code": "403",
            "label": "Mecenat nad działalnością kulturalną",
            "children": []
          },
          {
            "id": "404",
            "code": "404",
            "label": "Organizacja imprez kulturalnych, uroczystości, obchodów",
            "children": [
              {
                "id": "4040",
                "code": "4040",
                "label": "Organizacja imprez, uroczystości i obchodów stałych oraz periodycznych",
                "children": []
              },
              {
                "id": "4041",
                "code": "4041",
                "label": "Organizacja imprez, uroczystości i obchodów jednorazowych",
                "children": []
              }
            ]
          }
        ]
      },
      {
        "id": "41",
        "code": "41",
        "label": "Zabytki",
        "children": [
          {
            "id": "410",
            "code": "410",
            "label": "Wyjaśnienia, interpretacje, opinie, akty prawne dotyczące zagadnień z zakresu ochrony zabytków",
            "children": []
          },
          {
            "id": "411",
            "code": "411",
            "label": "Programy opieki nad zabytkami i sprawozdawczość w tym zakresie",
            "children": []
          },
          {
            "id": "412",
            "code": "412",
            "label": "Ochrona zabytków",
            "children": [
              {
                "id": "4120",
                "code": "4120",
                "label": "Zabytki nieruchome",
                "children": []
              },
              {
                "id": "4121",
                "code": "4121",
                "label": "Zabytki ruchome",
                "children": []
              },
              {
                "id": "4122",
                "code": "4122",
                "label": "Zgłaszanie o odkryciach lub ujawnieniach przedmiotów zabytkowych",
                "children": []
              },
              {
                "id": "4123",
                "code": "4123",
                "label": "Współdziałanie z wojewódzkim konserwatorem zabytków i otrzymywanie informacji z rejestrów zabytków",
                "children": []
              },
              {
                "id": "4124",
                "code": "4124",
                "label": "Przejmowanie w zarząd obiektu zabytkowego",
                "children": []
              },
              {
                "id": "4125",
                "code": "4125",
                "label": "Prace konserwatorskie, restauratorskie i roboty budowlane przy zabytku",
                "children": []
              },
              {
                "id": "4126",
                "code": "4126",
                "label": "Znakowanie obiektów zabytkowych",
                "children": []
              }
            ]
          },
          {
            "id": "413",
            "code": "413",
            "label": "Społeczni opiekunowie zabytków",
            "children": []
          },
          {
            "id": "414",
            "code": "414",
            "label": "Opieka nad pomnikami i miejscami pamięci",
            "children": []
          },
          {
            "id": "415",
            "code": "415",
            "label": "Parki kulturowe",
            "children": []
          },
          {
            "id": "416",
            "code": "416",
            "label": "Popularyzacja i upowszechnianie wiedzy o zabytkach",
            "children": []
          }
        ]
      },
      {
        "id": "42",
        "code": "42",
        "label": "Kultura fizyczna",
        "children": [
          {
            "id": "420",
            "code": "420",
            "label": "Wyjaśnienia, interpretacje, opinie, akty prawne dotyczące zagadnień z zakresu kultury fizycznej",
            "children": []
          },
          {
            "id": "421",
            "code": "421",
            "label": "Programy rozwoju kultury fizycznej oraz sprawozdawczość w tym zakresie",
            "children": []
          },
          {
            "id": "422",
            "code": "422",
            "label": "Prowadzenie ewidencji i rejestrów oraz dokumentacji jednostek organizacyjnych odpowiedzialnych za kulturę fizyczną",
            "children": [
              {
                "id": "4220",
                "code": "4220",
                "label": "Kluby sportowe, związki sportowe, stowarzyszenia kultury fizycznej",
                "children": []
              },
              {
                "id": "4221",
                "code": "4221",
                "label": "Uczniowskie kluby sportowe",
                "children": []
              },
              {
                "id": "4222",
                "code": "4222",
                "label": "Stowarzyszenia kultury fizycznej nieprowadzące działalności gospodarczej",
                "children": []
              },
              {
                "id": "4223",
                "code": "4223",
                "label": "Obiekty sportowe i rekreacyjne",
                "children": []
              }
            ]
          },
          {
            "id": "423",
            "code": "423",
            "label": "Opieka nad sportowcami oraz działalnością sportową",
            "children": []
          },
          {
            "id": "424",
            "code": "424",
            "label": "Popularyzacja walorów rekreacji ruchowej",
            "children": []
          },
          {
            "id": "425",
            "code": "425",
            "label": "Organizacja zajęć, zawodów i imprez sportowo-rekreacyjnych",
            "children": []
          },
          {
            "id": "426",
            "code": "426",
            "label": "Wspieranie jednostek organizacyjnych odpowiedzialnych za kulturę fizyczną",
            "children": []
          }
        ]
      },
      {
        "id": "43",
        "code": "43",
        "label": "Turystyka i wypoczynek",
        "children": [
          {
            "id": "430",
            "code": "430",
            "label": "Wyjaśnienia, interpretacje, opinie, akty prawne dotyczące zagadnień z zakresu turystyki i wypoczynku",
            "children": []
          },
          {
            "id": "431",
            "code": "431",
            "label": "Programy rozwoju turystyki i wypoczynku oraz sprawozdawczość w tym zakresie",
            "children": []
          },
          {
            "id": "432",
            "code": "432",
            "label": "Organizacja informacji turystycznej",
            "children": []
          },
          {
            "id": "433",
            "code": "433",
            "label": "Wyznaczanie szlaków turystycznych i tras rowerowych",
            "children": []
          },
          {
            "id": "434",
            "code": "434",
            "label": "Wspieranie działalności w zakresie turystyki i wypoczynku",
            "children": []
          }
        ]
      },
      {
        "id": "44",
        "code": "44",
        "label": "System oświaty",
        "children": [
          {
            "id": "440",
            "code": "440",
            "label": "Wyjaśnienia, interpretacje, opinie, akty prawne dotyczące zagadnień z zakresu systemu oświaty",
            "children": []
          },
          {
            "id": "441",
            "code": "441",
            "label": "Programy oświatowe oraz sprawozdawczość w tym zakresie",
            "children": []
          },
          {
            "id": "442",
            "code": "442",
            "label": "System oświaty publicznej",
            "children": [
              {
                "id": "4420",
                "code": "4420",
                "label": "Ustalanie sieci przedszkoli publicznych",
                "children": []
              },
              {
                "id": "4421",
                "code": "4421",
                "label": "Ustalanie sieci szkół publicznych oraz granic ich obwodów",
                "children": []
              },
              {
                "id": "4422",
                "code": "4422",
                "label": "Uzyskiwanie zezwoleń na założenie szkoły lub placówki publicznej",
                "children": []
              },
              {
                "id": "4423",
                "code": "4423",
                "label": "Nadawanie i cofanie uprawnień szkoły publicznej dla szkół niepublicznych",
                "children": []
              },
              {
                "id": "4424",
                "code": "4424",
                "label": "Nadzór nad działalnością szkół i placówek oświatowych",
                "children": []
              }
            ]
          },
          {
            "id": "443",
            "code": "443",
            "label": "Szkoły niepubliczne",
            "children": [
              {
                "id": "4430",
                "code": "4430",
                "label": "Prowadzenie ewidencji szkół niepublicznych",
                "children": []
              },
              {
                "id": "4431",
                "code": "4431",
                "label": "Wspieranie szkół niepublicznych",
                "children": []
              }
            ]
          },
          {
            "id": "444",
            "code": "444",
            "label": "System informacji oświatowej",
            "children": []
          },
          {
            "id": "445",
            "code": "445",
            "label": "Organizacja i realizacja zadań z zakresu nauczania i wychowania",
            "children": [
              {
                "id": "4450",
                "code": "4450",
                "label": "Realizacja obowiązku nauki oraz sprawy rekrutacji do szkół",
                "children": []
              },
              {
                "id": "4451",
                "code": "4451",
                "label": "Kierowanie dzieci do szkół specjalnych lub ośrodków poza granicami powiatu",
                "children": []
              },
              {
                "id": "4452",
                "code": "4452",
                "label": "Nauczanie indywidualne i rewalidacja indywidualna",
                "children": []
              },
              {
                "id": "4453",
                "code": "4453",
                "label": "Dofinansowanie kosztów kształcenia młodocianych",
                "children": []
              },
              {
                "id": "4454",
                "code": "4454",
                "label": "Pomoc psychologiczno-pedagogiczna i klasy integracyjne",
                "children": []
              },
              {
                "id": "4455",
                "code": "4455",
                "label": "Olimpiady i konkursy edukacyjne",
                "children": []
              }
            ]
          },
          {
            "id": "446",
            "code": "446",
            "label": "Wspieranie uczniów",
            "children": [
              {
                "id": "4460",
                "code": "4460",
                "label": "Programy pomocy materialnej dla uczniów",
                "children": []
              },
              {
                "id": "4461",
                "code": "4461",
                "label": "Przyznawanie zasiłków szkolnych uczniom",
                "children": []
              },
              {
                "id": "4462",
                "code": "4462",
                "label": "Przyznawanie stypendiów szkolnych uczniom",
                "children": []
              },
              {
                "id": "4463",
                "code": "4463",
                "label": "Pomoc materialna uczniom o charakterze motywacyjnym",
                "children": []
              },
              {
                "id": "4464",
                "code": "4464",
                "label": "Dowóz uczniów do szkół",
                "children": []
              }
            ]
          },
          {
            "id": "447",
            "code": "447",
            "label": "Rozwój zawodowy nauczycieli",
            "children": [
              {
                "id": "4470",
                "code": "4470",
                "label": "Awans zawodowy nauczycieli",
                "children": []
              },
              {
                "id": "4471",
                "code": "4471",
                "label": "Wspieranie doskonalenia zawodowego nauczycieli",
                "children": []
              },
              {
                "id": "4472",
                "code": "4472",
                "label": "Nagradzanie i wyróżnianie nauczycieli",
                "children": []
              }
            ]
          },
          {
            "id": "448",
            "code": "448",
            "label": "Sprawy nauczycieli",
            "children": [
              {
                "id": "4480",
                "code": "4480",
                "label": "Realizacja i wykorzystanie funduszu świadczeń socjalnych nauczycieli",
                "children": []
              },
              {
                "id": "4481",
                "code": "4481",
                "label": "Uzgodnienia ze związkami zawodowymi w sprawach dotyczących nauczycieli",
                "children": []
              }
            ]
          }
        ]
      }
    ]
  },
  {
    "id": "5",
    "code": "5",
    "label": "WYBORY, REFERENDA, SPISY POWSZECHNE, SPRAWY SPOŁECZNE I OBYWATELSKIE, STAN CYWILNY, OBSŁUGA LUDNOŚCI I JEJ BEZPIECZEŃSTWO",
    "children": [
      {
        "id": "50",
        "code": "50",
        "label": "Wybory i referenda, spisy powszechne",
        "children": [
          {
            "id": "500",
            "code": "500",
            "label": "Wyjaśnienia, interpretacje, opinie, akty prawne dotyczące wyborów i referendów, spisów powszechnych",
            "children": []
          },
          {
            "id": "501",
            "code": "501",
            "label": "Rejestry i spisy wyborców",
            "children": [
              {
                "id": "5010",
                "code": "5010",
                "label": "Prowadzenie i obsługa rejestru wyborców",
                "children": []
              },
              {
                "id": "5011",
                "code": "5011",
                "label": "Spisy wyborców",
                "children": []
              },
              {
                "id": "5012",
                "code": "5012",
                "label": "Udostępnianie danych z rejestru i spisów wyborców",
                "children": []
              }
            ]
          },
          {
            "id": "502",
            "code": "502",
            "label": "Obsługa organizacyjna wyborów",
            "children": []
          },
          {
            "id": "503",
            "code": "503",
            "label": "Obsługa organizacyjna referendów",
            "children": []
          },
          {
            "id": "504",
            "code": "504",
            "label": "Obsługa spisów powszechnych",
            "children": [
              {
                "id": "5040",
                "code": "5040",
                "label": "Gminne biura spisowe",
                "children": []
              },
              {
                "id": "5041",
                "code": "5041",
                "label": "Rachmistrze spisowi",
                "children": []
              },
              {
                "id": "5042",
                "code": "5042",
                "label": "Nadzorowanie prac spisowych",
                "children": []
              },
              {
                "id": "5043",
                "code": "5043",
                "label": "Popularyzacja spisów powszechnych",
                "children": []
              }
            ]
          }
        ]
      },
      {
        "id": "51",
        "code": "51",
        "label": "Stowarzyszenia i fundacje",
        "children": [
          {
            "id": "510",
            "code": "510",
            "label": "Wyjaśnienia, interpretacje, opinie, akty prawne dotyczące zagadnień z zakresu nadzoru nad stowarzyszeniami i fundacjami",
            "children": []
          },
          {
            "id": "511",
            "code": "511",
            "label": "Monitorowanie działalności stowarzyszeń",
            "children": []
          },
          {
            "id": "512",
            "code": "512",
            "label": "Monitorowanie działalności stowarzyszeń zwykłych",
            "children": []
          },
          {
            "id": "513",
            "code": "513",
            "label": "Monitorowanie działalności fundacji",
            "children": []
          },
          {
            "id": "514",
            "code": "514",
            "label": "Udostępnianie jednostkom zewnętrznym i osobom fizycznym informacji dotyczących działalności stowarzyszeń i fundacji",
            "children": []
          }
        ]
      },
      {
        "id": "52",
        "code": "52",
        "label": "Działalność organizacji pożytku publicznego",
        "children": [
          {
            "id": "520",
            "code": "520",
            "label": "Wyjaśnienia, interpretacje, opinie, akty prawne dotyczące działalności organizacji pożytku publicznego",
            "children": []
          },
          {
            "id": "521",
            "code": "521",
            "label": "Gminna Rada Działalności Pożytku Publicznego",
            "children": []
          },
          {
            "id": "522",
            "code": "522",
            "label": "Wspólne zespoły doradcze i opiniodawcze gminy i organizacji pożytku publicznego",
            "children": []
          },
          {
            "id": "523",
            "code": "523",
            "label": "Wymiana informacji o kierunkach działalności organizacji pożytku publicznego pomiędzy gminą i tymi organizacjami",
            "children": []
          },
          {
            "id": "524",
            "code": "524",
            "label": "Otwarte konkursy ofert w zakresie działalności pożytku publicznego",
            "children": []
          },
          {
            "id": "525",
            "code": "525",
            "label": "Oferty z własnej inicjatywy organizacji pożytku publicznego na realizację zadań z zakresu tej działalności",
            "children": []
          },
          {
            "id": "526",
            "code": "526",
            "label": "Realizacja zadań z zakresu działalności pożytku publicznego przez organizacje pożytku publicznego",
            "children": []
          }
        ]
      },
      {
        "id": "53",
        "code": "53",
        "label": "Sprawy społeczne i obywatelskie",
        "children": [
          {
            "id": "530",
            "code": "530",
            "label": "Wyjaśnienia, interpretacje, opinie, akty prawne dotyczące spraw społecznych i obywatelskich",
            "children": []
          },
          {
            "id": "531",
            "code": "531",
            "label": "Sprawy społeczne",
            "children": [
              {
                "id": "5310",
                "code": "5310",
                "label": "Zgromadzenia i imprezy masowe",
                "children": []
              },
              {
                "id": "5311",
                "code": "5311",
                "label": "Zbiórki publiczne",
                "children": []
              },
              {
                "id": "5312",
                "code": "5312",
                "label": "Mniejszości narodowe",
                "children": []
              },
              {
                "id": "5313",
                "code": "5313",
                "label": "Repatrianci",
                "children": []
              },
              {
                "id": "5314",
                "code": "5314",
                "label": "Obsługa rzeczy znalezionych",
                "children": []
              },
              {
                "id": "5315",
                "code": "5315",
                "label": "Przekazywanie do publicznej wiadomości informacji, zawiadomień itp. od innych organów.",
                "children": []
              }
            ]
          },
          {
            "id": "532",
            "code": "532",
            "label": "Przyjmowanie oświadczeń i poświadczenia",
            "children": [
              {
                "id": "5320",
                "code": "5320",
                "label": "Oświadczenia ostatniej woli spadkodawcy",
                "children": []
              },
              {
                "id": "5321",
                "code": "5321",
                "label": "Poświadczanie własnoręczności podpisu",
                "children": []
              },
              {
                "id": "5322",
                "code": "5322",
                "label": "Poświadczanie pozostawania osoby przy życiu lub w określonym miejscu",
                "children": []
              }
            ]
          },
          {
            "id": "533",
            "code": "533",
            "label": "Wybory ławników sądowych",
            "children": []
          },
          {
            "id": "534",
            "code": "534",
            "label": "Sprawy obywatelskie",
            "children": [
              {
                "id": "5340",
                "code": "5340",
                "label": "Obywatelstwo",
                "children": []
              },
              {
                "id": "5341",
                "code": "5341",
                "label": "Ewidencja ludności",
                "children": []
              },
              {
                "id": "5342",
                "code": "5342",
                "label": "Aktualizowanie danych w ewidencji ludności",
                "children": []
              },
              {
                "id": "5343",
                "code": "5343",
                "label": "Sprawy meldunkowe",
                "children": []
              },
              {
                "id": "5344",
                "code": "5344",
                "label": "Obsługa dowodów osobistych",
                "children": []
              },
              {
                "id": "5345",
                "code": "5345",
                "label": "Udostępnianie danych i wydawanie zaświadczeń z ewidencji ludności lub dokumentacji wydanych dowodów osobistych",
                "children": []
              }
            ]
          },
          {
            "id": "535",
            "code": "535",
            "label": "Stan cywilny",
            "children": [
              {
                "id": "5350",
                "code": "5350",
                "label": "Statystyka urodzeń, małżeństw, zgonów",
                "children": []
              },
              {
                "id": "5351",
                "code": "5351",
                "label": "Rejestracja aktów urodzenia, małżeństwa, zgonu i ich zmiany",
                "children": []
              },
              {
                "id": "5352",
                "code": "5352",
                "label": "Unieważnienie, sprostowanie, ustalenie treści, odtworzenie i uzupełnienie aktu stanu cywilnego",
                "children": []
              },
              {
                "id": "5353",
                "code": "5353",
                "label": "Wpisywanie akt stanu cywilnego sporządzonych za granicą do polskich ksiąg",
                "children": []
              },
              {
                "id": "5354",
                "code": "5354",
                "label": "Zezwolenia na zawarcie małżeństwa przed upływem miesiąca",
                "children": []
              },
              {
                "id": "5355",
                "code": "5355",
                "label": "Zmiany imion i nazwisk",
                "children": []
              },
              {
                "id": "5356",
                "code": "5356",
                "label": "Nadawanie medalu za długoletnie pożycie małżeńskie",
                "children": []
              }
            ]
          },
          {
            "id": "536",
            "code": "536",
            "label": "Udostępnianie i wymiana danych i informacji z akt stanu cywilnego oraz ich zabezpieczanie",
            "children": [
              {
                "id": "5360",
                "code": "5360",
                "label": "Zaświadczenia o zdolności do zawarcia małżeństwa za granicą",
                "children": []
              },
              {
                "id": "5361",
                "code": "5361",
                "label": "Zaświadczenia o braku okoliczności wyłączających zawarcie małżeństwa",
                "children": []
              },
              {
                "id": "5362",
                "code": "5362",
                "label": "Odpisy zupełne, skrócone i wielojęzyczne aktów stanu cywilnego",
                "children": []
              },
              {
                "id": "5363",
                "code": "5363",
                "label": "Powiadamianie innych podmiotów i jednostek organizacyjnych o zmianach dokonywanych w aktach stanu cywilnego",
                "children": []
              },
              {
                "id": "5364",
                "code": "5364",
                "label": "Udostępnianie innych informacji na podstawie akt stanu cywilnego",
                "children": []
              },
              {
                "id": "5365",
                "code": "5365",
                "label": "Profilaktyka i konserwacja akt stanu cywilnego",
                "children": []
              }
            ]
          },
          {
            "id": "537",
            "code": "537",
            "label": "Sprawy konsularne",
            "children": []
          }
        ]
      },
      {
        "id": "54",
        "code": "54",
        "label": "Rejestracja pojazdów, wydawanie uprawnień do kierowania pojazdami",
        "children": [
          {
            "id": "540",
            "code": "540",
            "label": "Wyjaśnienia, interpretacje, opinie, akty prawne dotyczące rejestracji pojazdów i wydawania uprawnień do kierowania pojazdami",
            "children": []
          },
          {
            "id": "541",
            "code": "541",
            "label": "Rejestracja pojazdów",
            "children": [
              {
                "id": "5410",
                "code": "5410",
                "label": "Dokumentacja rejestracji pojazdów",
                "children": []
              },
              {
                "id": "5411",
                "code": "5411",
                "label": "Udostępnianie danych i wydawanie zaświadczeń w zakresie rejestracji pojazdów",
                "children": []
              }
            ]
          },
          {
            "id": "542",
            "code": "542",
            "label": "Stacje kontroli pojazdów, diagności",
            "children": [
              {
                "id": "5420",
                "code": "5420",
                "label": "Rejestrowanie przedsiębiorców prowadzących stacje kontroli pojazdów",
                "children": []
              },
              {
                "id": "5421",
                "code": "5421",
                "label": "Nadzór nad działalnością stacji kontroli pojazdów",
                "children": []
              },
              {
                "id": "5422",
                "code": "5422",
                "label": "Wydawanie i cofanie uprawnień dla diagnostów",
                "children": []
              }
            ]
          },
          {
            "id": "543",
            "code": "543",
            "label": "Wydawanie uprawnień do kierowania pojazdami",
            "children": [
              {
                "id": "5430",
                "code": "5430",
                "label": "Ewidencjonowanie kierowców",
                "children": []
              },
              {
                "id": "5431",
                "code": "5431",
                "label": "Ewidencjonowanie osób bez uprawnień do kierowania pojazdami",
                "children": []
              },
              {
                "id": "5432",
                "code": "5432",
                "label": "Udostępnianie danych i wydawanie zaświadczeń w zakresie uprawnień do kierowania pojazdami",
                "children": []
              }
            ]
          },
          {
            "id": "544",
            "code": "544",
            "label": "Ośrodki szkolenia kierowców, instruktorzy nauki jazdy",
            "children": [
              {
                "id": "5440",
                "code": "5440",
                "label": "Rejestrowanie działalności przedsiębiorców prowadzących ośrodki szkolenia kierowców",
                "children": []
              },
              {
                "id": "5441",
                "code": "5441",
                "label": "Wpisywanie i skreślanie z ewidencji instruktorów",
                "children": []
              }
            ]
          }
        ]
      },
      {
        "id": "55",
        "code": "55",
        "label": "Bezpieczeństwo ludności, sprawy wojskowe i obronne",
        "children": [
          {
            "id": "550",
            "code": "550",
            "label": "Wyjaśnienia, interpretacje, opinie, akty prawne dotyczące bezpieczeństwa ludności, spraw wojskowych i obronnych",
            "children": []
          },
          {
            "id": "551",
            "code": "551",
            "label": "Komisja bezpieczeństwa i porządku",
            "children": [
              {
                "id": "5510",
                "code": "5510",
                "label": "Organizacja Komisji bezpieczeństwa i porządku",
                "children": []
              },
              {
                "id": "5511",
                "code": "5511",
                "label": "Posiedzenia Komisji bezpieczeństwa i porządku",
                "children": []
              }
            ]
          },
          {
            "id": "552",
            "code": "552",
            "label": "Bezpieczeństwo ludności",
            "children": [
              {
                "id": "5520",
                "code": "5520",
                "label": "Zapewnienie bezpieczeństwa mieszkańcom gminy i osobom przebywającym czasowo na terenie gminy",
                "children": []
              },
              {
                "id": "5521",
                "code": "5521",
                "label": "Organizacja i działalność straży gminnych (miejskich)",
                "children": []
              },
              {
                "id": "5522",
                "code": "5522",
                "label": "Współdziałanie z organizacjami zajmującymi się organizowaniem i niesieniem pomocy i ratunku",
                "children": []
              }
            ]
          },
          {
            "id": "553",
            "code": "553",
            "label": "Zarządzanie kryzysowe",
            "children": [
              {
                "id": "5530",
                "code": "5530",
                "label": "Prace Zespołu Zarządzania Kryzysowego",
                "children": []
              },
              {
                "id": "5531",
                "code": "5531",
                "label": "Monitorowanie działalności centrów zarządzania kryzysowego",
                "children": []
              },
              {
                "id": "5532",
                "code": "5532",
                "label": "Planowanie i prognozowanie działań w wypadku wystąpienia zagrożeń miejscowych oraz ich analizowanie",
                "children": []
              },
              {
                "id": "5533",
                "code": "5533",
                "label": "Planowanie i organizowanie systemów ostrzegania ludności",
                "children": []
              },
              {
                "id": "5534",
                "code": "5534",
                "label": "Organizacja łączności alarmowej",
                "children": []
              },
              {
                "id": "5535",
                "code": "5535",
                "label": "Zapobieganie i reagowanie w sytuacjach nadzwyczajnych i kryzysowych",
                "children": []
              }
            ]
          },
          {
            "id": "554",
            "code": "554",
            "label": "Ochrona przeciwpożarowa i przeciwpowodziowa",
            "children": [
              {
                "id": "5540",
                "code": "5540",
                "label": "Programowanie i analizowanie działalności straży pożarnej",
                "children": []
              },
              {
                "id": "5541",
                "code": "5541",
                "label": "Popularyzacja ochrony przeciwpożarowej",
                "children": []
              },
              {
                "id": "5542",
                "code": "5542",
                "label": "Szkolenie funkcjonariuszy straży pożarnej",
                "children": []
              },
              {
                "id": "5543",
                "code": "5543",
                "label": "Wyposażenie w sprzęt służb przeciwpożarowych",
                "children": []
              },
              {
                "id": "5544",
                "code": "5544",
                "label": "Planowanie zabezpieczenia gminy przed powodzią oraz analizowanie zagrożenia",
                "children": []
              },
              {
                "id": "5545",
                "code": "5545",
                "label": "Akcje przeciwpowodziowe",
                "children": []
              }
            ]
          },
          {
            "id": "555",
            "code": "555",
            "label": "Obrona cywilna",
            "children": [
              {
                "id": "5550",
                "code": "5550",
                "label": "Plany obrony cywilnej",
                "children": []
              },
              {
                "id": "5551",
                "code": "5551",
                "label": "Opracowywanie i uzgadnianie planów działania w zakresie obrony cywilnej",
                "children": []
              },
              {
                "id": "5552",
                "code": "5552",
                "label": "Organizacja formacji obronnych",
                "children": []
              },
              {
                "id": "5553",
                "code": "5553",
                "label": "Ocena stanu przygotowań obrony cywilnej",
                "children": []
              },
              {
                "id": "5554",
                "code": "5554",
                "label": "Organizacja ewakuacji ludności",
                "children": []
              },
              {
                "id": "5555",
                "code": "5555",
                "label": "Zaopatrzenie ludności i zakładów pracy w sprzęt obronny",
                "children": []
              },
              {
                "id": "5556",
                "code": "5556",
                "label": "Baza służąca obronie cywilnej",
                "children": []
              },
              {
                "id": "5557",
                "code": "5557",
                "label": "Popularyzacja obrony cywilnej oraz szkolenia w tym zakresie",
                "children": []
              }
            ]
          },
          {
            "id": "556",
            "code": "556",
            "label": "Sprawy obronne",
            "children": [
              {
                "id": "5560",
                "code": "5560",
                "label": "Planowanie w zakresie spraw obronnych",
                "children": []
              },
              {
                "id": "5561",
                "code": "5561",
                "label": "Organizowanie systemu kierowania obronnością",
                "children": []
              },
              {
                "id": "5562",
                "code": "5562",
                "label": "Przygotowanie publicznej i niepublicznej służby zdrowia na potrzeby obronne państwa",
                "children": []
              },
              {
                "id": "5563",
                "code": "5563",
                "label": "Przygotowanie obiektów i dróg o znaczeniu obronnym na potrzeby obronne państwa",
                "children": []
              },
              {
                "id": "5564",
                "code": "5564",
                "label": "Organizacja jednostek zmilitaryzowanych",
                "children": []
              },
              {
                "id": "5565",
                "code": "5565",
                "label": "Nakładanie obowiązku świadczeń osobistych na rzecz obronności i ich wykonywanie",
                "children": []
              },
              {
                "id": "5566",
                "code": "5566",
                "label": "Przeznaczanie nieruchomości i rzeczy ruchomych na cele świadczeń na rzecz obronności oraz wykonywanie tych świadczeń",
                "children": []
              },
              {
                "id": "5567",
                "code": "5567",
                "label": "Odszkodowania za utratę lub uszkodzenie oraz za szkody wynikłe z utrzymania przedmiotów świadczeń rzeczowych",
                "children": []
              },
              {
                "id": "5568",
                "code": "5568",
                "label": "Realizacja zadań na rzecz wojsk sojuszniczych wynikających z obowiązków państwa-gospodarza (HNS)",
                "children": []
              }
            ]
          },
          {
            "id": "557",
            "code": "557",
            "label": "Sprawy wojskowe oraz z zakresu kwalifikacji wojskowej",
            "children": [
              {
                "id": "5570",
                "code": "5570",
                "label": "Organizacja kwalifikacji wojskowej",
                "children": []
              },
              {
                "id": "5571",
                "code": "5571",
                "label": "Działalność komisji kwalifikacyjnej",
                "children": []
              },
              {
                "id": "5572",
                "code": "5572",
                "label": "Orzekanie w sprawach wojskowych",
                "children": []
              },
              {
                "id": "5573",
                "code": "5573",
                "label": "Reklamowanie osób od obowiązku pełnienia czynnej służby wojskowej w czasie ogłoszenia mobilizacji i czasie wojny",
                "children": []
              }
            ]
          }
        ]
      }
    ]
  },
  {
    "id": "6",
    "code": "6",
    "label": "KSZTAŁTOWANIE I OCHRONA ŚRODOWISKA, GOSPODAROWANIE ZASOBAMI PRZYRODY I ZIEMI, GEODEZJA I KARTOGRAFIA ORAZ PLANOWANIE PRZESTRZENNE, BUDOWNICTWO I GOSPODAROWANIE NIERUCHOMOŚCIAMI",
    "children": [
      {
        "id": "60",
        "code": "60",
        "label": "Kształtowanie i ochrona środowiska",
        "children": [
          {
            "id": "600",
            "code": "600",
            "label": "Wyjaśnienia, interpretacje, opinie, akty prawne dotyczące kształtowania i ochrony środowiska",
            "children": []
          },
          {
            "id": "601",
            "code": "601",
            "label": "Ustalanie i opiniowanie polityki ekologicznej",
            "children": []
          },
          {
            "id": "602",
            "code": "602",
            "label": "Programy, projekty, analizy z zakresu ochrony środowiska",
            "children": []
          },
          {
            "id": "603",
            "code": "603",
            "label": "Monitoring w zakresie ochrony środowiska",
            "children": []
          },
          {
            "id": "604",
            "code": "604",
            "label": "Informacje o środowisku i jego ochronie",
            "children": []
          },
          {
            "id": "605",
            "code": "605",
            "label": "Kształtowanie postaw proekologicznych",
            "children": []
          },
          {
            "id": "606",
            "code": "606",
            "label": "Wnioskowanie o ściganie za wykroczenia określone w przepisach prawa dotyczących ochrony przyrody i środowiska",
            "children": []
          },
          {
            "id": "607",
            "code": "607",
            "label": "Rozpatrywanie wniosków dotyczących udzielania dotacji celowych z zakresu ochrony środowiska",
            "children": []
          }
        ]
      },
      {
        "id": "61",
        "code": "61",
        "label": "Gospodarowanie zasobami przyrody",
        "children": [
          {
            "id": "610",
            "code": "610",
            "label": "Wyjaśnienia, interpretacje, opinie, akty prawne dotyczące gospodarowania zasobami przyrody",
            "children": []
          },
          {
            "id": "611",
            "code": "611",
            "label": "Programy, projekty, analizy z zakresu gospodarowania zasobami przyrody",
            "children": []
          },
          {
            "id": "612",
            "code": "612",
            "label": "Ochrona przyrody, gruntów rolnych i leśnych",
            "children": [
              {
                "id": "6120",
                "code": "6120",
                "label": "Ustanawianie form ochrony przyrody",
                "children": []
              },
              {
                "id": "6121",
                "code": "6121",
                "label": "Utrzymywanie form ochrony przyrody",
                "children": []
              },
              {
                "id": "6122",
                "code": "6122",
                "label": "Ochrona gatunkowa roślin i zwierząt",
                "children": []
              },
              {
                "id": "6123",
                "code": "6123",
                "label": "Zwierzęta i rośliny podlegające ograniczeniom przewozowym",
                "children": []
              },
              {
                "id": "6124",
                "code": "6124",
                "label": "Rekultywacja gruntów rolnych",
                "children": []
              },
              {
                "id": "6125",
                "code": "6125",
                "label": "Przeznaczanie gruntów rolnych i leśnych na cele nierolnicze i nieleśne",
                "children": []
              }
            ]
          },
          {
            "id": "613",
            "code": "613",
            "label": "Ochrona roślin, zieleni i zadrzewień",
            "children": [
              {
                "id": "6130",
                "code": "6130",
                "label": "Ustanawianie i ochrona zieleni, zadrzewień, parków gminnych",
                "children": []
              },
              {
                "id": "6131",
                "code": "6131",
                "label": "Zezwalanie na usuwanie drzew i krzewów",
                "children": []
              },
              {
                "id": "6132",
                "code": "6132",
                "label": "Nakładanie kar za zniszczenie, usuwanie, niewłaściwą pielęgnację terenów zieleni, drzew, krzewów",
                "children": []
              }
            ]
          },
          {
            "id": "614",
            "code": "614",
            "label": "Ochrona zwierząt i ochrona weterynaryjna",
            "children": [
              {
                "id": "6140",
                "code": "6140",
                "label": "Ochrona zwierząt gospodarskich i domowych",
                "children": []
              },
              {
                "id": "6141",
                "code": "6141",
                "label": "Informacje o posiadaczach i hodowcach zwierząt podlegających ochronie",
                "children": []
              },
              {
                "id": "6142",
                "code": "6142",
                "label": "Zwalczanie zakaźnych chorób zwierzęcych",
                "children": []
              },
              {
                "id": "6143",
                "code": "6143",
                "label": "Profilaktyka weterynaryjna i upowszechnianie higieny pozyskiwania produktów zwierzęcych",
                "children": []
              }
            ]
          },
          {
            "id": "615",
            "code": "615",
            "label": "Gospodarka łowiecka",
            "children": [
              {
                "id": "6150",
                "code": "6150",
                "label": "Administrowanie łowiectwem",
                "children": []
              },
              {
                "id": "6151",
                "code": "6151",
                "label": "Plany łowieckie",
                "children": []
              },
              {
                "id": "6152",
                "code": "6152",
                "label": "Zezwalanie na hodowlę chartów rasowych i ich mieszańców",
                "children": []
              }
            ]
          },
          {
            "id": "616",
            "code": "616",
            "label": "Ochrona lasów i gospodarka leśna w lasach niestanowiących własności Skarbu Państwa",
            "children": [
              {
                "id": "6160",
                "code": "6160",
                "label": "Powierzanie realizacji zadań z zakresu gospodarki leśnej",
                "children": []
              },
              {
                "id": "6161",
                "code": "6161",
                "label": "Roczne limity zalesienia",
                "children": []
              },
              {
                "id": "6162",
                "code": "6162",
                "label": "Uproszczone plany urządzenia lasów oraz inwentaryzacja stanu lasów",
                "children": []
              },
              {
                "id": "6163",
                "code": "6163",
                "label": "Kontrola realizacji zadań z zakresu gospodarki leśnej",
                "children": []
              },
              {
                "id": "6164",
                "code": "6164",
                "label": "Realizacja zadań z zakresu gospodarki leśnej",
                "children": []
              }
            ]
          },
          {
            "id": "617",
            "code": "617",
            "label": "Rybactwo śródlądowe",
            "children": [
              {
                "id": "6170",
                "code": "6170",
                "label": "Śródlądowe obwody rybackie",
                "children": []
              },
              {
                "id": "6171",
                "code": "6171",
                "label": "Nadzór nad śródlądową gospodarką rybacką",
                "children": []
              },
              {
                "id": "6172",
                "code": "6172",
                "label": "Wydawanie kart wędkarskich i kart łowiectwa podwodnego",
                "children": []
              },
              {
                "id": "6173",
                "code": "6173",
                "label": "Rejestracja sprzętu pływackiego służącego do połowu ryb",
                "children": []
              },
              {
                "id": "6174",
                "code": "6174",
                "label": "Zezwalanie na przegradzanie sieciowymi rybackimi narzędziami połowowymi wód płynących",
                "children": []
              },
              {
                "id": "6175",
                "code": "6175",
                "label": "Zezwalanie na ustawianie sieciowych rybackich narzędzi połowowych na wodach śródlądowych",
                "children": []
              }
            ]
          },
          {
            "id": "618",
            "code": "618",
            "label": "Produkcja roślinna",
            "children": [
              {
                "id": "6180",
                "code": "6180",
                "label": "Zezwalanie na uprawę maku i konopi",
                "children": []
              },
              {
                "id": "6181",
                "code": "6181",
                "label": "Ochrona roślin uprawnych przed chorobami i szkodnikami",
                "children": []
              },
              {
                "id": "6182",
                "code": "6182",
                "label": "Nakazy wykonania określonych czynności i zabiegów w zakresie ochron roślin",
                "children": []
              }
            ]
          }
        ]
      },
      {
        "id": "62",
        "code": "62",
        "label": "Wprowadzanie do środowiska substancji lub energii, gospodarowanie odpadami oraz ochrona przed hałasem",
        "children": [
          {
            "id": "620",
            "code": "620",
            "label": "Wyjaśnienia, interpretacje, opinie, akty prawne dotyczące wprowadzania do środowiska substancji lub energii, gospodarowania odpadami oraz ochrony przed hałasem",
            "children": []
          },
          {
            "id": "621",
            "code": "621",
            "label": "Programy, projekty, analizy z zakresu wprowadzania do środowiska substancji lub energii, gospodarowania odpadami oraz ochrony przed hałasem",
            "children": []
          },
          {
            "id": "622",
            "code": "622",
            "label": "Wprowadzanie substancji lub energii do środowiska",
            "children": [
              {
                "id": "6220",
                "code": "6220",
                "label": "Ustalanie wpływu realizacji inwestycji na środowisko",
                "children": []
              },
              {
                "id": "6221",
                "code": "6221",
                "label": "Pozwalanie na wprowadzanie do środowiska substancji lub energii",
                "children": []
              },
              {
                "id": "6222",
                "code": "6222",
                "label": "Zgłaszanie eksploatacji instalacji, których użytkowanie nie wymaga pozwolenia",
                "children": []
              },
              {
                "id": "6223",
                "code": "6223",
                "label": "Pozwolenia zintegrowane w zakresie wprowadzania substancji lub energii do środowiska",
                "children": []
              },
              {
                "id": "6224",
                "code": "6224",
                "label": "Pomiary wielkości emisji zanieczyszczeń powietrza",
                "children": []
              },
              {
                "id": "6225",
                "code": "6225",
                "label": "Pozwolenia na wprowadzanie gazów i pyłów do powietrza",
                "children": []
              },
              {
                "id": "6226",
                "code": "6226",
                "label": "Wydawanie opinii w zakresie ochrony przed substancjami lub polami elektromagnetycznymi",
                "children": []
              },
              {
                "id": "6227",
                "code": "6227",
                "label": "Uczestnictwo w systemie handlu uprawnieniami do emisji i monitorowanie wielkości emisji",
                "children": []
              },
              {
                "id": "6228",
                "code": "6228",
                "label": "Bilanse źródeł szkodliwego zanieczyszczenia powietrza",
                "children": []
              }
            ]
          },
          {
            "id": "623",
            "code": "623",
            "label": "Gospodarka odpadami",
            "children": [
              {
                "id": "6230",
                "code": "6230",
                "label": "Zatwierdzanie programów gospodarki odpadami niebezpiecznymi",
                "children": []
              },
              {
                "id": "6231",
                "code": "6231",
                "label": "Informacje o poważnych awariach",
                "children": []
              },
              {
                "id": "6232",
                "code": "6232",
                "label": "Informacje o wytwarzaniu odpadów oraz sposobach gospodarowania odpadami",
                "children": []
              },
              {
                "id": "6233",
                "code": "6233",
                "label": "Zezwalanie na prowadzenie odzyskiwania, unieszkodliwiania, zbierania lub transportu odpadów",
                "children": []
              },
              {
                "id": "6234",
                "code": "6234",
                "label": "Opiniowanie wniosków o wydanie zezwoleń na prowadzenie odzyskiwania lub unieszkodliwiania odpadów",
                "children": []
              },
              {
                "id": "6235",
                "code": "6235",
                "label": "Zgłaszanie posiadania oraz prowadzenia transportu odpadów",
                "children": []
              },
              {
                "id": "6236",
                "code": "6236",
                "label": "Nakazy usunięcia odpadów z miejsc nieprzeznaczonych do ich składowania lub magazynowania",
                "children": []
              },
              {
                "id": "6237",
                "code": "6237",
                "label": "Zezwolenia na międzynarodowe przemieszczanie odpadów oraz zezwolenia wstępne na prowadzenie instalacji, w której prowadzone są procesy odzysku",
                "children": []
              }
            ]
          },
          {
            "id": "624",
            "code": "624",
            "label": "Opłaty za gospodarcze korzystanie ze środowiska",
            "children": []
          },
          {
            "id": "625",
            "code": "625",
            "label": "Ochrona przed hałasem",
            "children": [
              {
                "id": "6250",
                "code": "6250",
                "label": "Mapy akustyczne",
                "children": []
              },
              {
                "id": "6251",
                "code": "6251",
                "label": "Decydowanie o dopuszczalnym poziomie hałasu, w tym pozwolenia na emitowanie hałasu do środowiska",
                "children": []
              },
              {
                "id": "6252",
                "code": "6252",
                "label": "Zgłaszanie instalacji emitujących hałas, których eksploatacja nie wymaga pozwolenia",
                "children": []
              },
              {
                "id": "6253",
                "code": "6253",
                "label": "Pomiary emisji hałasu",
                "children": []
              },
              {
                "id": "6254",
                "code": "6254",
                "label": "Wydawanie opinii w zakresie ochrony przed hałasem",
                "children": []
              }
            ]
          }
        ]
      },
      {
        "id": "63",
        "code": "63",
        "label": "Ochrona wód i gospodarowanie wodami",
        "children": [
          {
            "id": "630",
            "code": "630",
            "label": "Wyjaśnienia, interpretacje, opinie, akty prawne dotyczące ochrony wód i gospodarowania wodami",
            "children": []
          },
          {
            "id": "631",
            "code": "631",
            "label": "Programy, projekty, analizy z zakresu ochrony wód i gospodarowania wodami",
            "children": []
          },
          {
            "id": "632",
            "code": "632",
            "label": "Ochrona wód oraz ochrona przed powodzią i suszą",
            "children": [
              {
                "id": "6320",
                "code": "6320",
                "label": "Ustalanie stref ochronnych ujęć wody",
                "children": []
              },
              {
                "id": "6321",
                "code": "6321",
                "label": "Studium ochrony przeciwpowodziowej",
                "children": []
              },
              {
                "id": "6322",
                "code": "6322",
                "label": "Odszkodowania w związku z zalaniem gruntów podczas powodzi",
                "children": []
              },
              {
                "id": "6323",
                "code": "6323",
                "label": "Nakazy usunięcia drzew i krzewów",
                "children": []
              },
              {
                "id": "6324",
                "code": "6324",
                "label": "Przeciwdziałanie zanieczyszczeniom wód",
                "children": []
              }
            ]
          },
          {
            "id": "633",
            "code": "633",
            "label": "Prawo własności wód",
            "children": [
              {
                "id": "6330",
                "code": "6330",
                "label": "Ustalanie linii brzegu",
                "children": []
              },
              {
                "id": "6331",
                "code": "6331",
                "label": "Naruszenie stanu wody na gruncie",
                "children": []
              },
              {
                "id": "6332",
                "code": "6332",
                "label": "Użytkowanie gruntów pokrytych wodami",
                "children": []
              }
            ]
          },
          {
            "id": "634",
            "code": "634",
            "label": "Zarządzanie zasobami wodnymi",
            "children": [
              {
                "id": "6340",
                "code": "6340",
                "label": "Ustalanie stref ochronnych urządzeń pomiarowych państwowej sieci hydrologiczno-meteorologicznej",
                "children": []
              },
              {
                "id": "6341",
                "code": "6341",
                "label": "Pozwolenia wodnoprawne",
                "children": []
              },
              {
                "id": "6342",
                "code": "6342",
                "label": "Zgłaszanie instalacji wodnych, których eksploatacja nie wymaga pozwolenia",
                "children": []
              },
              {
                "id": "6343",
                "code": "6343",
                "label": "Spółki wodne",
                "children": []
              },
              {
                "id": "6344",
                "code": "6344",
                "label": "Ewidencjonowanie kąpielisk",
                "children": []
              }
            ]
          },
          {
            "id": "635",
            "code": "635",
            "label": "Rejestracja jachtów i innych jednostek pływających",
            "children": []
          }
        ]
      },
      {
        "id": "64",
        "code": "64",
        "label": "Ochrona powierzchni ziemi",
        "children": [
          {
            "id": "640",
            "code": "640",
            "label": "Wyjaśnienia, interpretacje, opinie, akty prawne dotyczące ochrony powierzchni ziemi",
            "children": []
          },
          {
            "id": "641",
            "code": "641",
            "label": "Programy, projekty, analizy z zakresu ochrony powierzchni ziemi",
            "children": []
          },
          {
            "id": "642",
            "code": "642",
            "label": "Badanie jakości gleby i ziemi",
            "children": []
          },
          {
            "id": "643",
            "code": "643",
            "label": "Obserwacje terenów zagrożonych ruchami masowymi ziemi oraz terenów, na których występują te ruchy",
            "children": []
          },
          {
            "id": "644",
            "code": "644",
            "label": "Uzgodnienia w odniesieniu do terenów zagrożonych osuwaniem się mas ziemnych",
            "children": []
          },
          {
            "id": "645",
            "code": "645",
            "label": "Wydawanie opinii w zakresie ochrony powierzchni ziemi",
            "children": []
          }
        ]
      },
      {
        "id": "65",
        "code": "65",
        "label": "Gospodarowanie złożami i kopalinami",
        "children": [
          {
            "id": "650",
            "code": "650",
            "label": "Wyjaśnienia, interpretacje, opinie, akty prawne dotyczące gospodarowania złożami i kopalinami",
            "children": []
          },
          {
            "id": "651",
            "code": "651",
            "label": "Programy, projekty, analizy z zakresu gospodarowania złożami i kopalinami",
            "children": []
          },
          {
            "id": "652",
            "code": "652",
            "label": "Geologia surowcowa",
            "children": [
              {
                "id": "6520",
                "code": "6520",
                "label": "Ewidencja złóż kopalin",
                "children": []
              },
              {
                "id": "6521",
                "code": "6521",
                "label": "Inwentaryzacja i bilanse zasobów złóż kopalin",
                "children": []
              },
              {
                "id": "6522",
                "code": "6522",
                "label": "Przyznawanie koncesji na poszukiwanie, rozpoznawanie i wydobywanie kopalin pospolitych",
                "children": []
              },
              {
                "id": "6523",
                "code": "6523",
                "label": "Opiniowanie koncesji na poszukiwanie, rozpoznawanie i wydobywanie kopalin pospolitych",
                "children": []
              },
              {
                "id": "6524",
                "code": "6524",
                "label": "Opiniowanie planów ruchu zakładu górniczego",
                "children": []
              },
              {
                "id": "6525",
                "code": "6525",
                "label": "Analizy wykonawstwa prac w zakresie geologii surowcowej",
                "children": []
              },
              {
                "id": "6526",
                "code": "6526",
                "label": "Zatwierdzanie kryteriów bilansowości złóż",
                "children": []
              },
              {
                "id": "6527",
                "code": "6527",
                "label": "Zatwierdzanie projektu zagospodarowania złoża",
                "children": []
              },
              {
                "id": "6528",
                "code": "6528",
                "label": "Przyjmowanie dokumentacji ustalającej zasoby złóż kopalin pospolitych",
                "children": []
              }
            ]
          },
          {
            "id": "653",
            "code": "653",
            "label": "Hydrogeologia",
            "children": [
              {
                "id": "6530",
                "code": "6530",
                "label": "Zatwierdzanie projektów prac hydrogeologicznych",
                "children": []
              },
              {
                "id": "6531",
                "code": "6531",
                "label": "Przyjmowanie dokumentacji hydrogeologicznych",
                "children": []
              }
            ]
          },
          {
            "id": "654",
            "code": "654",
            "label": "Geologia inżynierska",
            "children": [
              {
                "id": "6540",
                "code": "6540",
                "label": "Zatwierdzanie projektów prac geologiczno-inżynierskich",
                "children": []
              },
              {
                "id": "6541",
                "code": "6541",
                "label": "Przyjmowanie dokumentacji geologiczno-inżynierskiej",
                "children": []
              }
            ]
          },
          {
            "id": "655",
            "code": "655",
            "label": "Inne prace geologiczne",
            "children": []
          },
          {
            "id": "656",
            "code": "656",
            "label": "Szkody górnicze",
            "children": [
              {
                "id": "6560",
                "code": "6560",
                "label": "Analizy i informacje dotyczące występowania szkód górniczych",
                "children": []
              },
              {
                "id": "6561",
                "code": "6561",
                "label": "Programy, plany, sprawozdania w zakresie usuwania szkód górniczych",
                "children": []
              },
              {
                "id": "6562",
                "code": "6562",
                "label": "Koordynacja zamierzeń i współpraca z innymi instytucjami w zakresie zapobiegania i likwidacji szkód",
                "children": []
              },
              {
                "id": "6563",
                "code": "6563",
                "label": "Orzekanie w sprawie szkód górniczych",
                "children": []
              },
              {
                "id": "6564",
                "code": "6564",
                "label": "Ewidencja budynków mieszkalnych zakwalifikowanych do rozbiórki na skutek szkód górniczych",
                "children": []
              },
              {
                "id": "6565",
                "code": "6565",
                "label": "Przeglądy okresowe budynków przeznaczonych do rozbiórki na skutek szkód",
                "children": []
              }
            ]
          },
          {
            "id": "657",
            "code": "657",
            "label": "Nadzór nad robotami geologicznymi",
            "children": [
              {
                "id": "6570",
                "code": "6570",
                "label": "Nadzór i kontrola nad prowadzeniem badań i sporządzaniem dokumentacji geologicznej",
                "children": []
              },
              {
                "id": "6571",
                "code": "6571",
                "label": "Orzecznictwo w sprawach szkód powstałych w związku z robotami geologicznymi",
                "children": []
              },
              {
                "id": "6572",
                "code": "6572",
                "label": "Zezwolenia na prowadzenie prac geologicznych",
                "children": []
              },
              {
                "id": "6573",
                "code": "6573",
                "label": "Kontrola realizacji planów prac geologicznych",
                "children": []
              }
            ]
          },
          {
            "id": "658",
            "code": "658",
            "label": "Informacja geologiczna i zawiadomienia",
            "children": [
              {
                "id": "6580",
                "code": "6580",
                "label": "Informacja geologiczna",
                "children": []
              },
              {
                "id": "6581",
                "code": "6581",
                "label": "Zawiadomienia o odkryciu kopalnych roślin lub zwierząt",
                "children": []
              }
            ]
          }
        ]
      },
      {
        "id": "66",
        "code": "66",
        "label": "Geodezja i kartografia",
        "children": [
          {
            "id": "660",
            "code": "660",
            "label": "Wyjaśnienia, interpretacje, opinie, akty prawne dotyczące geodezji i kartografii",
            "children": []
          },
          {
            "id": "661",
            "code": "661",
            "label": "Programy, projekty, analizy z zakresu geodezji i kartografii",
            "children": []
          },
          {
            "id": "662",
            "code": "662",
            "label": "Ewidencjonowanie gruntów i budynków",
            "children": [
              {
                "id": "6620",
                "code": "6620",
                "label": "Obsługa ewidencji gruntów i budynków",
                "children": []
              },
              {
                "id": "6621",
                "code": "6621",
                "label": "Informacje, wypisy oraz wyrysy z operatu ewidencyjnego",
                "children": []
              },
              {
                "id": "6622",
                "code": "6622",
                "label": "Zmiana formy użytkowania gruntów",
                "children": []
              },
              {
                "id": "6623",
                "code": "6623",
                "label": "Aktualizacja użytków gruntowych",
                "children": []
              },
              {
                "id": "6624",
                "code": "6624",
                "label": "Numeracja porządkowa nieruchomości",
                "children": []
              },
              {
                "id": "6625",
                "code": "6625",
                "label": "Nazewnictwo placów i ulic",
                "children": []
              }
            ]
          },
          {
            "id": "663",
            "code": "663",
            "label": "Sieć uzbrojenia terenu",
            "children": [
              {
                "id": "6630",
                "code": "6630",
                "label": "Koordynacja usytuowania projektowanych sieci uzbrojenia terenu",
                "children": []
              },
              {
                "id": "6631",
                "code": "6631",
                "label": "Nadzór nad prowadzeniem prac związanych z siecią uzbrojenia terenu",
                "children": []
              }
            ]
          },
          {
            "id": "664",
            "code": "664",
            "label": "Państwowy zasób geodezyjny i kartograficzny",
            "children": [
              {
                "id": "6640",
                "code": "6640",
                "label": "Obsługa państwowego zasobu geodezyjnego i kartograficznego",
                "children": []
              },
              {
                "id": "6641",
                "code": "6641",
                "label": "Nadzór nad pracami geodezyjnymi i kartograficznymi oraz zlecanie prowadzenia prac geodezyjnych i kartograficznych",
                "children": []
              },
              {
                "id": "6642",
                "code": "6642",
                "label": "Udostępnianie państwowego zasobu geodezyjno-kartograficznego",
                "children": []
              },
              {
                "id": "6643",
                "code": "6643",
                "label": "Ochrona znaków geodezyjnych, grawimetrycznych i magnetycznych",
                "children": []
              }
            ]
          }
        ]
      },
      {
        "id": "67",
        "code": "67",
        "label": "Planowanie i zagospodarowanie przestrzenne oraz sprawy budownictwa",
        "children": [
          {
            "id": "670",
            "code": "670",
            "label": "Wyjaśnienia, interpretacje, opinie, akty prawne dotyczące planowania i zagospodarowania przestrzennego oraz spraw budownictwa",
            "children": []
          },
          {
            "id": "671",
            "code": "671",
            "label": "Programy, projekty, analizy z zakresu planowania i zagospodarowania przestrzennego oraz spraw budownictwa",
            "children": []
          },
          {
            "id": "672",
            "code": "672",
            "label": "Planowanie i zagospodarowanie przestrzenne",
            "children": [
              {
                "id": "6720",
                "code": "6720",
                "label": "Studium uwarunkowań i kierunków zagospodarowania przestrzennego",
                "children": []
              },
              {
                "id": "6721",
                "code": "6721",
                "label": "Ustalanie miejscowego planu zagospodarowania przestrzennego",
                "children": []
              },
              {
                "id": "6722",
                "code": "6722",
                "label": "Miejscowy plan zagospodarowania przestrzennego",
                "children": []
              },
              {
                "id": "6723",
                "code": "6723",
                "label": "Nadzór nad realizacją ustaleń planów zagospodarowania przestrzennego",
                "children": []
              },
              {
                "id": "6724",
                "code": "6724",
                "label": "Przeznaczenie terenów w miejscowym planie zagospodarowania przestrzennego",
                "children": []
              },
              {
                "id": "6725",
                "code": "6725",
                "label": "Roszczenia w związku ze zmianą wartości nieruchomości w miejscowym planie zagospodarowania przestrzennego",
                "children": []
              },
              {
                "id": "6726",
                "code": "6726",
                "label": "Okresowe oceny skutków zmian w zagospodarowaniu przestrzennym wynikających z realizacji planu miejscowego",
                "children": []
              },
              {
                "id": "6727",
                "code": "6727",
                "label": "Wydawanie wypisów, wyrysów, zaświadczeń, itp. w zakresie planowania i zagospodarowania przestrzennego",
                "children": []
              }
            ]
          },
          {
            "id": "673",
            "code": "673",
            "label": "Lokalizacja inwestycji",
            "children": [
              {
                "id": "6730",
                "code": "6730",
                "label": "Ustalanie warunków zabudowy i zagospodarowania terenu",
                "children": []
              },
              {
                "id": "6731",
                "code": "6731",
                "label": "Wstrzymywanie użytkowania terenu oraz przywracanie poprzedniego sposobu zagospodarowania",
                "children": []
              },
              {
                "id": "6732",
                "code": "6732",
                "label": "Stwierdzanie wygaśnięcia decyzji o warunkach zabudowy i zagospodarowania terenu",
                "children": []
              },
              {
                "id": "6733",
                "code": "6733",
                "label": "Ustalanie lokalizacji inwestycji celu publicznego",
                "children": []
              }
            ]
          },
          {
            "id": "674",
            "code": "674",
            "label": "Budownictwo",
            "children": [
              {
                "id": "6740",
                "code": "6740",
                "label": "Pozwolenia na budowę, przebudowę i rozbudowę obiektów budowlanych oraz zmiany sposobu użytkowania obiektów budowlanych lub ich części",
                "children": []
              },
              {
                "id": "6741",
                "code": "6741",
                "label": "Rozbiórka obiektów budowlanych",
                "children": []
              },
              {
                "id": "6742",
                "code": "6742",
                "label": "Zezwolenia na wejście w teren sąsiedniej nieruchomości w celu wykonania niezbędnych robót budowlanych",
                "children": []
              },
              {
                "id": "6743",
                "code": "6743",
                "label": "Zgłaszanie zamiaru przystąpienia do wykonywania robót budowlanych, rozbiórki, zmiany sposobu użytkowania obiektu budowlanego lub jego części",
                "children": []
              }
            ]
          }
        ]
      },
      {
        "id": "68",
        "code": "68",
        "label": "Gospodarowanie nieruchomościami",
        "children": [
          {
            "id": "680",
            "code": "680",
            "label": "Wyjaśnienia, interpretacje, opinie, akty prawne dotyczące gospodarowania nieruchomościami",
            "children": []
          },
          {
            "id": "681",
            "code": "681",
            "label": "Wiedza o nieruchomościach i jej aktualizacja",
            "children": [
              {
                "id": "6810",
                "code": "6810",
                "label": "Ewidencja nieruchomości",
                "children": []
              },
              {
                "id": "6811",
                "code": "6811",
                "label": "Inwentaryzowanie nieruchomości",
                "children": []
              },
              {
                "id": "6812",
                "code": "6812",
                "label": "Oszacowanie wartości i wycena nieruchomości",
                "children": []
              }
            ]
          },
          {
            "id": "682",
            "code": "682",
            "label": "Stan prawny nieruchomości",
            "children": [
              {
                "id": "6820",
                "code": "6820",
                "label": "Przejmowanie nieruchomości na rzecz Skarbu Państwa",
                "children": []
              },
              {
                "id": "6821",
                "code": "6821",
                "label": "Wykonywanie, ograniczanie, pozbawianie praw do nieruchomości oraz zwrot nieruchomości",
                "children": []
              },
              {
                "id": "6822",
                "code": "6822",
                "label": "Przejmowanie nieruchomości na rzecz gminy",
                "children": []
              },
              {
                "id": "6823",
                "code": "6823",
                "label": "Zakup nieruchomości",
                "children": []
              },
              {
                "id": "6824",
                "code": "6824",
                "label": "Zniesienie współwłasności nieruchomości",
                "children": []
              },
              {
                "id": "6825",
                "code": "6825",
                "label": "Komunalizacja mienia Skarbu Państwa",
                "children": []
              },
              {
                "id": "6826",
                "code": "6826",
                "label": "Przekształcanie prawa użytkowania wieczystego w prawo własności",
                "children": []
              }
            ]
          },
          {
            "id": "683",
            "code": "683",
            "label": "Rozgraniczanie, scalanie i podział nieruchomości",
            "children": [
              {
                "id": "6830",
                "code": "6830",
                "label": "Rozgraniczanie nieruchomości",
                "children": []
              },
              {
                "id": "6831",
                "code": "6831",
                "label": "Podział nieruchomości",
                "children": []
              },
              {
                "id": "6832",
                "code": "6832",
                "label": "Scalanie nieruchomości",
                "children": []
              },
              {
                "id": "6833",
                "code": "6833",
                "label": "Odszkodowania za nieruchomości przejęte pod drogi publiczne",
                "children": []
              }
            ]
          },
          {
            "id": "684",
            "code": "684",
            "label": "Zarządzanie nieruchomościami",
            "children": [
              {
                "id": "6840",
                "code": "6840",
                "label": "Sprzedaż nieruchomości",
                "children": []
              },
              {
                "id": "6841",
                "code": "6841",
                "label": "Oddawanie nieruchomości w użytkowanie wieczyste",
                "children": []
              },
              {
                "id": "6842",
                "code": "6842",
                "label": "Rozwiązywanie i wygaszanie umów użytkowania wieczystego",
                "children": []
              },
              {
                "id": "6843",
                "code": "6843",
                "label": "Opłaty za użytkowanie wieczyste",
                "children": []
              },
              {
                "id": "6844",
                "code": "6844",
                "label": "Oddawanie nieruchomości w trwały zarząd",
                "children": []
              },
              {
                "id": "6845",
                "code": "6845",
                "label": "Przekazywanie nieruchomości do korzystania, w tym w dzierżawę lub najem",
                "children": []
              },
              {
                "id": "6846",
                "code": "6846",
                "label": "Przekazywanie nieruchomości na cele szczególne",
                "children": []
              },
              {
                "id": "6847",
                "code": "6847",
                "label": "Służebności gruntowe",
                "children": []
              }
            ]
          },
          {
            "id": "685",
            "code": "685",
            "label": "Użyczenia nieruchomości",
            "children": [
              {
                "id": "6850",
                "code": "6850",
                "label": "Użyczanie nieruchomości",
                "children": []
              },
              {
                "id": "6851",
                "code": "6851",
                "label": "Udostępnianie nieruchomości pod lokalizację nośników reklamowych",
                "children": []
              },
              {
                "id": "6852",
                "code": "6852",
                "label": "Zezwolenia na czasowe zajęcie nieruchomości",
                "children": []
              },
              {
                "id": "6853",
                "code": "6853",
                "label": "Zezwolenia na zakładanie, przeprowadzanie i wykonanie na nieruchomościach urządzeń technicznych",
                "children": []
              }
            ]
          },
          {
            "id": "686",
            "code": "686",
            "label": "Tereny pod budownictwo mieszkaniowe",
            "children": [
              {
                "id": "6860",
                "code": "6860",
                "label": "Tworzenie zasobu gruntów na cele rozbudowy pod budownictwo mieszkaniowe",
                "children": []
              },
              {
                "id": "6861",
                "code": "6861",
                "label": "Stan prawny terenów pod budownictwo mieszkaniowe",
                "children": []
              },
              {
                "id": "6862",
                "code": "6862",
                "label": "Planowanie szczegółowe dla terenów pod budownictwo mieszkaniowe",
                "children": []
              },
              {
                "id": "6863",
                "code": "6863",
                "label": "Zarządzanie zasobem terenów na cele budownictwa mieszkaniowego",
                "children": []
              }
            ]
          },
          {
            "id": "687",
            "code": "687",
            "label": "Nadzór nad zarządzaniem gruntami",
            "children": [
              {
                "id": "6870",
                "code": "6870",
                "label": "Organizacja zarządzania gruntami",
                "children": []
              },
              {
                "id": "6871",
                "code": "6871",
                "label": "Nadzór i kontrola zarządzania gruntami",
                "children": []
              },
              {
                "id": "6872",
                "code": "6872",
                "label": "Opiniowanie sposobu zarządzania gruntami",
                "children": []
              },
              {
                "id": "6873",
                "code": "6873",
                "label": "Wspólnoty gruntowe",
                "children": []
              }
            ]
          }
        ]
      }
    ]
  },
  {
    "id": "7",
    "code": "7",
    "label": "GOSPODARKA KOMUNALNA, DROGOWNICTWO, SYSTEM KOMUNIKACYJNY, WSPIERANIE GOSPODARKI, RYNKU PRACY ORAZ PRAW KONSUMENCKICH",
    "children": [
      {
        "id": "70",
        "code": "70",
        "label": "Gospodarka komunalna",
        "children": [
          {
            "id": "700",
            "code": "700",
            "label": "Zagadnienia ogólne w zakresie gospodarki komunalnej",
            "children": [
              {
                "id": "7000",
                "code": "7000",
                "label": "Wyjaśnienia, interpretacje, opinie, akty prawne dotyczące zagadnień z zakresu gospodarki komunalnej",
                "children": []
              },
              {
                "id": "7001",
                "code": "7001",
                "label": "Analizowanie, prognozowanie i planowanie z zakresu prowadzenia gospodarki komunalnej",
                "children": []
              },
              {
                "id": "7002",
                "code": "7002",
                "label": "Przekazywanie zadań z zakresu prowadzenia gospodarki komunalnej",
                "children": []
              },
              {
                "id": "7003",
                "code": "7003",
                "label": "Nadzorowanie i monitorowanie realizacji przekazanych zadań z zakresu prowadzenia gospodarki komunalnej",
                "children": []
              }
            ]
          },
          {
            "id": "701",
            "code": "701",
            "label": "Inwestycje komunalne",
            "children": [
              {
                "id": "7010",
                "code": "7010",
                "label": "Planowanie inwestycji komunalnych",
                "children": []
              },
              {
                "id": "7011",
                "code": "7011",
                "label": "Przygotowanie inwestycji komunalnej",
                "children": []
              },
              {
                "id": "7012",
                "code": "7012",
                "label": "Opiniowanie i zatwierdzanie dokumentacji inwestycji komunalnych",
                "children": []
              },
              {
                "id": "7013",
                "code": "7013",
                "label": "Realizacja i odbiór inwestycji komunalnych",
                "children": []
              },
              {
                "id": "7014",
                "code": "7014",
                "label": "Ewidencja inwestycji komunalnych",
                "children": []
              }
            ]
          },
          {
            "id": "702",
            "code": "702",
            "label": "Utrzymanie, eksploatacja i zarządzanie obiektami i urządzeniami komunalnymi",
            "children": [
              {
                "id": "7020",
                "code": "7020",
                "label": "Ewidencja obiektów i urządzeń komunalnych",
                "children": []
              },
              {
                "id": "7021",
                "code": "7021",
                "label": "Utrzymanie i eksploatacja obiektów i urządzeń komunalnych",
                "children": []
              }
            ]
          },
          {
            "id": "703",
            "code": "703",
            "label": "Usługi komunalne",
            "children": [
              {
                "id": "7030",
                "code": "7030",
                "label": "Ustalanie wysokości opłat za usługi komunalne oraz zatwierdzanie cenników opłat za usługi komunalne",
                "children": []
              },
              {
                "id": "7031",
                "code": "7031",
                "label": "Zlecanie podmiotom zewnętrznym świadczenia usług komunalnych",
                "children": []
              },
              {
                "id": "7032",
                "code": "7032",
                "label": "Kontrolowanie jakości dostarczanych usług komunalnych",
                "children": []
              },
              {
                "id": "7033",
                "code": "7033",
                "label": "Badania i analizy w zakresie jakości świadczonych usług komunalnych",
                "children": []
              }
            ]
          },
          {
            "id": "704",
            "code": "704",
            "label": "Zarządzanie cmentarzami",
            "children": [
              {
                "id": "7040",
                "code": "7040",
                "label": "Zakładanie, rozszerzanie i likwidacja cmentarzy komunalnych",
                "children": []
              },
              {
                "id": "7041",
                "code": "7041",
                "label": "Ewidencja cmentarzy na terenie jednostki samorządu",
                "children": []
              },
              {
                "id": "7042",
                "code": "7042",
                "label": "Ewidencja cmentarna",
                "children": []
              },
              {
                "id": "7043",
                "code": "7043",
                "label": "Projekty kwater (miejsc grzebalnych)",
                "children": []
              },
              {
                "id": "7044",
                "code": "7044",
                "label": "Przydział miejsc grzebalnych",
                "children": []
              },
              {
                "id": "7045",
                "code": "7045",
                "label": "Utrzymanie miejsc grzebalnych",
                "children": []
              },
              {
                "id": "7046",
                "code": "7046",
                "label": "Ekshumacje",
                "children": []
              },
              {
                "id": "7047",
                "code": "7047",
                "label": "Udostępnianie danych i informacji z ewidencji cmentarnej",
                "children": []
              },
              {
                "id": "7048",
                "code": "7048",
                "label": "Zezwalanie na sprowadzanie zwłok i szczątków ludzkich zza granicy w celu ich pochowania",
                "children": []
              },
              {
                "id": "7049",
                "code": "7049",
                "label": "Przekazywanie zwłok do celów  naukowych",
                "children": []
              }
            ]
          }
        ]
      },
      {
        "id": "71",
        "code": "71",
        "label": "Gospodarowanie budynkami, mieszkaniami i lokalami",
        "children": [
          {
            "id": "710",
            "code": "710",
            "label": "Wyjaśnienia, interpretacje, opinie, akty prawne dotyczące zagadnień z zakresu gospodarowania budynkami, mieszkaniami i lokalami",
            "children": []
          },
          {
            "id": "711",
            "code": "711",
            "label": "Zagadnienia ogólne w zakresie gospodarowania budynkami, mieszkaniami i lokalami",
            "children": [
              {
                "id": "7110",
                "code": "7110",
                "label": "Wieloletnie programy gospodarowania mieszkaniowym i lokalowym zasobem gminy",
                "children": []
              },
              {
                "id": "7111",
                "code": "7111",
                "label": "Pozyskiwanie budynków i lokali na cele komunalne",
                "children": []
              },
              {
                "id": "7112",
                "code": "7112",
                "label": "Pozyskiwanie wsparcia finansowego na tworzenie lokali socjalnych, mieszkań chronionych, noclegowni, domów dla bezdomnych, lokali wchodzących w skład mieszkaniowego zasobu gminy nie będących lokalami socjalnymi",
                "children": []
              },
              {
                "id": "7113",
                "code": "7113",
                "label": "Analizowanie cen najmu lokali mieszkalnych nienależących do publicznego zasobu mieszkaniowego",
                "children": []
              },
              {
                "id": "7114",
                "code": "7114",
                "label": "Ustalanie zasad najmu lokali oraz wysokości opłat za najem lokali",
                "children": []
              }
            ]
          },
          {
            "id": "712",
            "code": "712",
            "label": "Stan prawny budynków, mieszkań i lokali",
            "children": [
              {
                "id": "7120",
                "code": "7120",
                "label": "Samodzielność lokali mieszkalnych",
                "children": []
              },
              {
                "id": "7121",
                "code": "7121",
                "label": "Ustanawianie odrębnej własności lokali",
                "children": []
              },
              {
                "id": "7122",
                "code": "7122",
                "label": "Znoszenie współwłasności nieruchomości",
                "children": []
              },
              {
                "id": "7123",
                "code": "7123",
                "label": "Ustalanie tytułów prawnych do lokali",
                "children": []
              },
              {
                "id": "7124",
                "code": "7124",
                "label": "Ustalanie i poświadczanie stanu prawnego nieruchomości i lokali",
                "children": []
              },
              {
                "id": "7125",
                "code": "7125",
                "label": "Wykup mieszkań i lokali przez najemców",
                "children": []
              },
              {
                "id": "7126",
                "code": "7126",
                "label": "Teczki zbiorcze na dokumentację budynków, lokali i mieszkań",
                "children": []
              }
            ]
          },
          {
            "id": "713",
            "code": "713",
            "label": "Zarząd nieruchomością wspólną",
            "children": [
              {
                "id": "7130",
                "code": "7130",
                "label": "Wspólnoty mieszkaniowe",
                "children": []
              },
              {
                "id": "7131",
                "code": "7131",
                "label": "Powierzanie podmiotom zewnętrznym zarządu nieruchomościami",
                "children": []
              },
              {
                "id": "7132",
                "code": "7132",
                "label": "Kontrolowanie prawidłowości sprawowania zarządu nieruchomościami",
                "children": []
              },
              {
                "id": "7133",
                "code": "7133",
                "label": "Kontrolowanie prawidłowości wykorzystania lokali",
                "children": []
              },
              {
                "id": "7134",
                "code": "7134",
                "label": "Przejmowanie ruchomości w depozyt",
                "children": []
              },
              {
                "id": "7135",
                "code": "7135",
                "label": "Przebudowa lokali",
                "children": []
              }
            ]
          },
          {
            "id": "714",
            "code": "714",
            "label": "Zaspokajanie potrzeb mieszkaniowych wspólnoty gminnej",
            "children": [
              {
                "id": "7140",
                "code": "7140",
                "label": "Ustalanie uprawnień do najmu lokali z mieszkaniowego zasobu gminy",
                "children": []
              },
              {
                "id": "7141",
                "code": "7141",
                "label": "Przyznawanie lokali mieszkalnych zamiennych",
                "children": []
              },
              {
                "id": "7142",
                "code": "7142",
                "label": "Zapewnianie lokali mieszkalnych socjalnych",
                "children": []
              },
              {
                "id": "7143",
                "code": "7143",
                "label": "Postępowanie o opróżnienie lokalu mieszkalnego",
                "children": []
              },
              {
                "id": "7144",
                "code": "7144",
                "label": "Zamiana lokali mieszkalnych",
                "children": []
              },
              {
                "id": "7145",
                "code": "7145",
                "label": "Zawieranie umów o odpłatne używanie lokali mieszkalnych",
                "children": []
              },
              {
                "id": "7146",
                "code": "7146",
                "label": "Zadłużenie czynszowe lokali mieszkalnych",
                "children": []
              },
              {
                "id": "7147",
                "code": "7147",
                "label": "Podnajem lokali mieszkalnych",
                "children": []
              }
            ]
          },
          {
            "id": "715",
            "code": "715",
            "label": "Lokale użytkowe",
            "children": [
              {
                "id": "7150",
                "code": "7150",
                "label": "Przetargi na wynajem lokali użytkowych",
                "children": []
              },
              {
                "id": "7151",
                "code": "7151",
                "label": "Umowy na wynajem lokali użytkowych",
                "children": []
              },
              {
                "id": "7152",
                "code": "7152",
                "label": "Przyznawanie pomocy publicznej w zakresie wynajmu lokali użytkowych",
                "children": []
              },
              {
                "id": "7153",
                "code": "7153",
                "label": "Zadłużenie czynszowe lokali użytkowych",
                "children": []
              }
            ]
          },
          {
            "id": "716",
            "code": "716",
            "label": "Teczki zbiorcze na dokumentację lokali mieszkalnych i użytkowych",
            "children": []
          }
        ]
      },
      {
        "id": "72",
        "code": "72",
        "label": "Drogownictwo i system komunikacyjny",
        "children": [
          {
            "id": "720",
            "code": "720",
            "label": "Wyjaśnienia, interpretacje, opinie, akty prawne dotyczące zagadnień z zakresu drogownictwa i systemu komunikacyjnego",
            "children": []
          },
          {
            "id": "721",
            "code": "721",
            "label": "Zarządzanie drogami",
            "children": [
              {
                "id": "7210",
                "code": "7210",
                "label": "Zaliczanie dróg do określonej kategorii",
                "children": []
              },
              {
                "id": "7211",
                "code": "7211",
                "label": "Opinie w sprawie przebiegu dróg",
                "children": []
              }
            ]
          },
          {
            "id": "722",
            "code": "722",
            "label": "Organizacja i bezpieczeństwo ruchu drogowego",
            "children": [
              {
                "id": "7220",
                "code": "7220",
                "label": "Ewidencja zatwierdzonych projektów zmian organizacji ruchu drogowego",
                "children": []
              },
              {
                "id": "7221",
                "code": "7221",
                "label": "Projekty zmian organizacji ruchu drogowego",
                "children": []
              },
              {
                "id": "7222",
                "code": "7222",
                "label": "Pomiary ruchu drogowego",
                "children": []
              },
              {
                "id": "7223",
                "code": "7223",
                "label": "Znaki drogowe i sygnalizacja drogowa",
                "children": []
              },
              {
                "id": "7224",
                "code": "7224",
                "label": "Wypadki drogowe",
                "children": []
              },
              {
                "id": "7225",
                "code": "7225",
                "label": "Okresowe kontrole stanu dróg i obiektów mostowych",
                "children": []
              },
              {
                "id": "7226",
                "code": "7226",
                "label": "Współdziałanie w zakresie organizacji i bezpieczeństwa ruchu drogowego",
                "children": []
              }
            ]
          },
          {
            "id": "723",
            "code": "723",
            "label": "Nadzór nad wykorzystaniem dróg",
            "children": [
              {
                "id": "7230",
                "code": "7230",
                "label": "Zezwolenia na korzystanie z dróg w sposób szczególny",
                "children": []
              },
              {
                "id": "7231",
                "code": "7231",
                "label": "Ustalanie miejsc postoju i opłat za parkowanie",
                "children": []
              },
              {
                "id": "7232",
                "code": "7232",
                "label": "Ustalanie stref taryfowych taxi",
                "children": []
              },
              {
                "id": "7233",
                "code": "7233",
                "label": "Wydawanie kart parkingowych",
                "children": []
              },
              {
                "id": "7234",
                "code": "7234",
                "label": "Przeciwdziałanie niszczeniu dróg",
                "children": []
              },
              {
                "id": "7235",
                "code": "7235",
                "label": "Usuwanie pojazdów",
                "children": []
              }
            ]
          },
          {
            "id": "724",
            "code": "724",
            "label": "System komunikacyjny",
            "children": [
              {
                "id": "7240",
                "code": "7240",
                "label": "Planowanie i organizowanie publicznego transportu zbiorowego",
                "children": []
              },
              {
                "id": "7241",
                "code": "7241",
                "label": "Studia, analizy, badania dotyczące komunikacji",
                "children": []
              },
              {
                "id": "7242",
                "code": "7242",
                "label": "Opiniowanie rozwiązań i projektów dotyczących komunikacji zbiorowej i przewozów taksówką",
                "children": []
              },
              {
                "id": "7243",
                "code": "7243",
                "label": "Nadzór nad realizacją usług gminnego transportu publicznego",
                "children": []
              },
              {
                "id": "7244",
                "code": "7244",
                "label": "Działalność marketingowa, reklamowa i promocyjna w zakresie transportu",
                "children": []
              }
            ]
          }
        ]
      },
      {
        "id": "73",
        "code": "73",
        "label": "Wspieranie gospodarki i rynku pracy",
        "children": [
          {
            "id": "730",
            "code": "730",
            "label": "Wyjaśnienia, interpretacje, opinie, akty prawne dotyczące zagadnień z zakresu wspierania gospodarki i rynku pracy",
            "children": []
          },
          {
            "id": "731",
            "code": "731",
            "label": "Polityka gospodarcza",
            "children": [
              {
                "id": "7310",
                "code": "7310",
                "label": "Strategia rozwoju gospodarczego",
                "children": []
              },
              {
                "id": "7311",
                "code": "7311",
                "label": "Realizacja strategii rozwoju gospodarczego i planów operacyjnych",
                "children": []
              },
              {
                "id": "7312",
                "code": "7312",
                "label": "Analizy i oceny stanu oraz perspektyw rozwoju gospodarczego",
                "children": []
              },
              {
                "id": "7313",
                "code": "7313",
                "label": "Pozyskiwanie środków pozabudżetowych i pomocowych na rozwój gminy",
                "children": []
              }
            ]
          },
          {
            "id": "732",
            "code": "732",
            "label": "Promocja gospodarcza",
            "children": [
              {
                "id": "7320",
                "code": "7320",
                "label": "Konkursy i nagrody gospodarcze",
                "children": []
              },
              {
                "id": "7321",
                "code": "7321",
                "label": "Wspieranie aktywności gospodarczej mieszkańców",
                "children": []
              },
              {
                "id": "7322",
                "code": "7322",
                "label": "Pozyskiwanie inwestorów",
                "children": []
              },
              {
                "id": "7323",
                "code": "7323",
                "label": "Informacja gospodarcza",
                "children": []
              },
              {
                "id": "7324",
                "code": "7324",
                "label": "Specjalne strefy ekonomiczne",
                "children": []
              }
            ]
          },
          {
            "id": "733",
            "code": "733",
            "label": "Działalność gospodarcza",
            "children": [
              {
                "id": "7330",
                "code": "7330",
                "label": "Wykonywanie zadań z zakresu obsługi ewidencji działalności gospodarczej",
                "children": []
              },
              {
                "id": "7331",
                "code": "7331",
                "label": "Poświadczenia o wpisie do ewidencji działalności gospodarczej z innych urzędów",
                "children": []
              },
              {
                "id": "7332",
                "code": "7332",
                "label": "Poświadczanie danych ze zbioru ewidencji działalności gospodarczej",
                "children": []
              },
              {
                "id": "7333",
                "code": "7333",
                "label": "Ewidencja pól biwakowych i ich kategoryzacja",
                "children": []
              },
              {
                "id": "7334",
                "code": "7334",
                "label": "Ewidencja miejsc noclegowych",
                "children": []
              },
              {
                "id": "7335",
                "code": "7335",
                "label": "Ustalanie godzin pracy placówek",
                "children": []
              }
            ]
          },
          {
            "id": "734",
            "code": "734",
            "label": "Zezwolenia, licencje i zgłoszenia",
            "children": [
              {
                "id": "7340",
                "code": "7340",
                "label": "Zezwolenia na sprzedaż alkoholu",
                "children": []
              },
              {
                "id": "7341",
                "code": "7341",
                "label": "Udzielanie licencji na wykonywanie krajowego transportu drogowego osób i rzeczy",
                "children": []
              },
              {
                "id": "7342",
                "code": "7342",
                "label": "Zezwolenia na wykonywanie przewozów w transporcie drogowym",
                "children": []
              },
              {
                "id": "7343",
                "code": "7343",
                "label": "Zgłoszenia przewozów drogowych na potrzeby własne",
                "children": []
              },
              {
                "id": "7344",
                "code": "7344",
                "label": "Udzielanie licencji na wykonywanie transportu drogowego taksówką",
                "children": []
              },
              {
                "id": "7345",
                "code": "7345",
                "label": "Egzaminowanie osób, które ukończyły szkolenie w zakresie transportu drogowego taksówką",
                "children": []
              },
              {
                "id": "7346",
                "code": "7346",
                "label": "Nadzór nad prowadzeniem działalności zgodnie z zezwoleniem (licencją)",
                "children": []
              }
            ]
          },
          {
            "id": "735",
            "code": "735",
            "label": "Pomoc publiczna dla przedsiębiorców",
            "children": [
              {
                "id": "7350",
                "code": "7350",
                "label": "Programy pomocy publicznej przedsiębiorcom",
                "children": []
              },
              {
                "id": "7351",
                "code": "7351",
                "label": "Udzielanie pomocy publicznej przedsiębiorcom",
                "children": []
              },
              {
                "id": "7352",
                "code": "7352",
                "label": "Sprawozdawczość w zakresie udzielonej przedsiębiorcom pomocy publicznej",
                "children": []
              }
            ]
          },
          {
            "id": "736",
            "code": "736",
            "label": "Rynek pracy",
            "children": [
              {
                "id": "7360",
                "code": "7360",
                "label": "Powoływanie składu Powiatowej Rady Zatrudnienia",
                "children": []
              },
              {
                "id": "7361",
                "code": "7361",
                "label": "Powiatowa Rada Zatrudnienia",
                "children": []
              },
              {
                "id": "7362",
                "code": "7362",
                "label": "Analizy, obserwacje i badanie rynku pracy",
                "children": []
              },
              {
                "id": "7363",
                "code": "7363",
                "label": "Monitorowanie działalności organów i urzędów odpowiedzialnych za działanie w zakresie walki z bezrobociem i wspierania rynku pracy",
                "children": []
              },
              {
                "id": "7364",
                "code": "7364",
                "label": "Wyznaczanie podmiotów, w których odbywana jest kara ograniczenia wolności oraz praca społecznie użyteczna",
                "children": []
              }
            ]
          }
        ]
      },
      {
        "id": "74",
        "code": "74",
        "label": "Ochrona praw konsumenckich",
        "children": [
          {
            "id": "740",
            "code": "740",
            "label": "Wyjaśnienia, interpretacje, opinie, akty prawne dotyczące zagadnień z zakresu ochrony praw konsumenckich",
            "children": []
          },
          {
            "id": "741",
            "code": "741",
            "label": "Poradnictwo w zakresie ochrony praw konsumenckich",
            "children": []
          },
          {
            "id": "742",
            "code": "742",
            "label": "Postępowania w zakresie praw konsumenckich",
            "children": []
          },
          {
            "id": "743",
            "code": "743",
            "label": "Edukacja konsumencka",
            "children": []
          }
        ]
      }
    ]
  },
  {
    "id": "8",
    "code": "8",
    "label": "OCHRONA ZDROWIA I POMOC SPOŁECZNA",
    "children": [
      {
        "id": "80",
        "code": "80",
        "label": "Ochrona zdrowia",
        "children": [
          {
            "id": "800",
            "code": "800",
            "label": "Wyjaśnienia, interpretacje, opinie, akty prawne dotyczące zagadnień z zakresu ochrony zdrowia",
            "children": []
          },
          {
            "id": "801",
            "code": "801",
            "label": "Programowanie działań oraz monitorowanie sytuacji w ochronie zdrowia",
            "children": [
              {
                "id": "8010",
                "code": "8010",
                "label": "Programy w zakresie ochrony zdrowia",
                "children": []
              },
              {
                "id": "8011",
                "code": "8011",
                "label": "Udział w programach i projektach zewnętrznych w zakresie ochrony zdrowia",
                "children": []
              },
              {
                "id": "8012",
                "code": "8012",
                "label": "Analizy i oceny potrzeb zdrowotnych i stanu zdrowia mieszkańców",
                "children": []
              },
              {
                "id": "8013",
                "code": "8013",
                "label": "Analizy i oceny efektów realizowanych programów zdrowotnych",
                "children": []
              },
              {
                "id": "8014",
                "code": "8014",
                "label": "Przygotowywanie danych do Wojewódzkiego Planu Zdrowotnego",
                "children": []
              },
              {
                "id": "8015",
                "code": "8015",
                "label": "Plan zabezpieczenia medycznych działań ratowniczych",
                "children": []
              }
            ]
          },
          {
            "id": "802",
            "code": "802",
            "label": "Organizacja opieki zdrowotnej",
            "children": [
              {
                "id": "8020",
                "code": "8020",
                "label": "Stan prawny i własnościowy zakładów opieki zdrowotnej",
                "children": []
              },
              {
                "id": "8021",
                "code": "8021",
                "label": "Rady społeczne zakładów opieki zdrowotnej",
                "children": []
              },
              {
                "id": "8022",
                "code": "8022",
                "label": "Rozpatrywanie odwołań od uchwał rad społecznych",
                "children": []
              },
              {
                "id": "8023",
                "code": "8023",
                "label": "Nadzór nad zakładami opieki zdrowotnej",
                "children": []
              },
              {
                "id": "8024",
                "code": "8024",
                "label": "Analizowanie i ocenianie działalności zakładów opieki zdrowotnej",
                "children": []
              }
            ]
          },
          {
            "id": "803",
            "code": "803",
            "label": "Promocja zdrowia i edukacja zdrowotna",
            "children": [
              {
                "id": "8030",
                "code": "8030",
                "label": "Organizacja i realizacja działań w zakresie promocji zdrowia i edukacji zdrowotnej",
                "children": []
              },
              {
                "id": "8031",
                "code": "8031",
                "label": "Współdziałanie z różnymi jednostkami organizacyjnymi zajmującymi się promocją zdrowia i edukacją zdrowotną",
                "children": []
              }
            ]
          },
          {
            "id": "804",
            "code": "804",
            "label": "Ubezpieczanie zdrowotne osób nieubezpieczonych",
            "children": []
          },
          {
            "id": "805",
            "code": "805",
            "label": "Sprawy sanitarne i przeciwepidemiczne",
            "children": [
              {
                "id": "8050",
                "code": "8050",
                "label": "Ochrona zdrowia publicznego przed zakażeniami i chorobami zakaźnymi",
                "children": []
              },
              {
                "id": "8051",
                "code": "8051",
                "label": "Plany działań na wypadek wystąpienia epidemii",
                "children": []
              }
            ]
          }
        ]
      },
      {
        "id": "81",
        "code": "81",
        "label": "Pomoc społeczna",
        "children": [
          {
            "id": "810",
            "code": "810",
            "label": "Wyjaśnienia, interpretacje, opinie, akty prawne dotyczące zagadnień z zakresu pomocy społecznej",
            "children": []
          },
          {
            "id": "811",
            "code": "811",
            "label": "Programy i analizy w zakresie pomocy społecznej",
            "children": [
              {
                "id": "8110",
                "code": "8110",
                "label": "Programy w zakresie pomocy społecznej",
                "children": []
              },
              {
                "id": "8111",
                "code": "8111",
                "label": "Udział w programach i projektach zewnętrznych",
                "children": []
              },
              {
                "id": "8112",
                "code": "8112",
                "label": "Analizowanie sytuacji w zakresie pomocy społecznej",
                "children": []
              }
            ]
          },
          {
            "id": "812",
            "code": "812",
            "label": "Realizacja zadań w zakresie pomocy społecznej",
            "children": [
              {
                "id": "8120",
                "code": "8120",
                "label": "Współdziałanie z jednostkami realizującymi zadania pomocy społecznej",
                "children": []
              },
              {
                "id": "8121",
                "code": "8121",
                "label": "Umowy i porozumienia z jednostkami realizującymi zadania pomocy społecznej",
                "children": []
              },
              {
                "id": "8122",
                "code": "8122",
                "label": "Otwarte konkursy ofert na realizację zadań z zakresu pomocy społecznej",
                "children": []
              },
              {
                "id": "8123",
                "code": "8123",
                "label": "Oferty z własnej inicjatywy podmiotów zewnętrznych na realizację zadań z zakresu pomocy społecznej",
                "children": []
              },
              {
                "id": "8124",
                "code": "8124",
                "label": "Realizacja przez podmioty zewnętrzne zadań z zakresu pomocy społecznej",
                "children": []
              },
              {
                "id": "8125",
                "code": "8125",
                "label": "Opiniowanie sytuacji osób przebywających na terenie gminy dla instytucji zewnętrznych",
                "children": []
              },
              {
                "id": "8126",
                "code": "8126",
                "label": "Zastępstwo prawne w sprawach z zakresu pomocy społecznej",
                "children": []
              },
              {
                "id": "8127",
                "code": "8127",
                "label": "Wnioskowanie w sprawach niezdolności do pracy i niepełnosprawności",
                "children": []
              }
            ]
          },
          {
            "id": "813",
            "code": "813",
            "label": "Praca socjalna",
            "children": [
              {
                "id": "8130",
                "code": "8130",
                "label": "Poradnictwo specjalistyczne",
                "children": []
              },
              {
                "id": "8131",
                "code": "8131",
                "label": "Interwencja kryzysowa",
                "children": []
              },
              {
                "id": "8132",
                "code": "8132",
                "label": "Pomoc kombatantom i osobom represjonowanym",
                "children": []
              },
              {
                "id": "8133",
                "code": "8133",
                "label": "Pomoc cudzoziemcom, uchodźcom i repatriantom",
                "children": []
              },
              {
                "id": "8134",
                "code": "8134",
                "label": "Pomoc osobom bezdomnym",
                "children": []
              },
              {
                "id": "8135",
                "code": "8135",
                "label": "Zapobieganie patologiom społecznym",
                "children": []
              },
              {
                "id": "8136",
                "code": "8136",
                "label": "Szkolenia i poradnictwo rodzinne",
                "children": []
              }
            ]
          },
          {
            "id": "814",
            "code": "814",
            "label": "Profilaktyka alkoholowa",
            "children": [
              {
                "id": "8140",
                "code": "8140",
                "label": "Prowadzenie świetlic środowiskowych finansowanych z profilaktyki alkoholowej",
                "children": []
              },
              {
                "id": "8141",
                "code": "8141",
                "label": "Dodatkowe zadania podejmowane w ramach profilaktyki alkoholowej",
                "children": []
              }
            ]
          },
          {
            "id": "815",
            "code": "815",
            "label": "Kierowanie dziecka do placówki opiekuńczo-wychowawczej oraz monitorowanie jego pobytu",
            "children": []
          },
          {
            "id": "816",
            "code": "816",
            "label": "Udzielanie pomocy wychowankom i podopiecznym placówek opiekuńczo-wychowawczych",
            "children": []
          },
          {
            "id": "817",
            "code": "817",
            "label": "Rodziny zastępcze",
            "children": [
              {
                "id": "8170",
                "code": "8170",
                "label": "Dobór rodzin zastępczych",
                "children": []
              },
              {
                "id": "8171",
                "code": "8171",
                "label": "Opiniowanie rodzin zastępczych",
                "children": []
              },
              {
                "id": "8172",
                "code": "8172",
                "label": "Monitorowanie pobytu dziecka w rodzinie zastępczej",
                "children": []
              },
              {
                "id": "8173",
                "code": "8173",
                "label": "Rozliczenia finansowe w zakresie pobytu dziecka w rodzinie zastępczej",
                "children": []
              }
            ]
          }
        ]
      },
      {
        "id": "82",
        "code": "82",
        "label": "Obsługa świadczeń w zakresie pomocy społecznej",
        "children": [
          {
            "id": "820",
            "code": "820",
            "label": "Wyjaśnienia, interpretacje, opinie, akty prawne dotyczące zagadnień z zakresu udzielania świadczeń pomocy społecznej",
            "children": []
          },
          {
            "id": "821",
            "code": "821",
            "label": "Świadczenia pieniężne",
            "children": [
              {
                "id": "8210",
                "code": "8210",
                "label": "Zasiłki stałe",
                "children": []
              },
              {
                "id": "8211",
                "code": "8211",
                "label": "Zasiłki okresowe (w tym specjalne)",
                "children": []
              },
              {
                "id": "8212",
                "code": "8212",
                "label": "Zasiłki celowe (w tym specjalne)",
                "children": []
              },
              {
                "id": "8213",
                "code": "8213",
                "label": "Zasiłki i pożyczki w celu ekonomicznego usamodzielnienia",
                "children": []
              },
              {
                "id": "8214",
                "code": "8214",
                "label": "Zasiłki celowe w związku z klęską żywiołową lub ekologiczną",
                "children": []
              },
              {
                "id": "8215",
                "code": "8215",
                "label": "Zasiłki celowe w związku ze zdarzeniem losowym",
                "children": []
              },
              {
                "id": "8216",
                "code": "8216",
                "label": "Zasiłki celowe na pokrycie wydatków na świadczenia zdrowotne",
                "children": []
              },
              {
                "id": "8217",
                "code": "8217",
                "label": "Opłacanie składki na ubezpieczenia emerytalne i rentowe",
                "children": []
              }
            ]
          },
          {
            "id": "822",
            "code": "822",
            "label": "Świadczenia niepieniężne",
            "children": [
              {
                "id": "8220",
                "code": "8220",
                "label": "Udzielanie pomocy rzeczowej",
                "children": []
              },
              {
                "id": "8221",
                "code": "8221",
                "label": "Sprawienie pogrzebu",
                "children": []
              },
              {
                "id": "8222",
                "code": "8222",
                "label": "Udzielanie schronienia",
                "children": []
              },
              {
                "id": "8223",
                "code": "8223",
                "label": "Dożywianie",
                "children": []
              },
              {
                "id": "8224",
                "code": "8224",
                "label": "Udzielanie posiłku potrzebującym",
                "children": []
              },
              {
                "id": "8225",
                "code": "8225",
                "label": "Zapewnianie usług opiekuńczych, w tym specjalistycznych",
                "children": []
              },
              {
                "id": "8226",
                "code": "8226",
                "label": "Kierowanie do domów pomocy społecznej",
                "children": []
              },
              {
                "id": "8227",
                "code": "8227",
                "label": "Kierowanie do ośrodków wsparcia",
                "children": []
              },
              {
                "id": "8228",
                "code": "8228",
                "label": "Przyznawanie pobytu w mieszkaniu chronionym",
                "children": []
              }
            ]
          },
          {
            "id": "823",
            "code": "823",
            "label": "Sprawy osób niepełnosprawnych rozpatrywane na poziomie gminy",
            "children": []
          },
          {
            "id": "824",
            "code": "824",
            "label": "Obsługa dodatków mieszkaniowych",
            "children": []
          },
          {
            "id": "825",
            "code": "825",
            "label": "Realizacja świadczeń rodzinnych",
            "children": [
              {
                "id": "8250",
                "code": "8250",
                "label": "Zasiłki rodzinne i dodatki do zasiłków rodzinnych",
                "children": []
              },
              {
                "id": "8251",
                "code": "8251",
                "label": "Zasiłki pielęgnacyjne",
                "children": []
              },
              {
                "id": "8252",
                "code": "8252",
                "label": "Świadczenia pielęgnacyjne",
                "children": []
              },
              {
                "id": "8253",
                "code": "8253",
                "label": "Jednorazowa zapomoga z tytułu urodzenia się dziecka",
                "children": []
              },
              {
                "id": "8254",
                "code": "8254",
                "label": "Zapomoga finansowana ze środków własnych gminy z tytułu urodzenia się dziecka",
                "children": []
              },
              {
                "id": "8255",
                "code": "8255",
                "label": "Jednorazowe świadczenie z tytułu urodzenia dziecka - \"Za życiem\"",
                "children": []
              }
            ]
          },
          {
            "id": "826",
            "code": "826",
            "label": "Teczki zbiorcze na dokumentację wnioskodawców świadczeń pomocy społecznej i świadczeń rodzinnych",
            "children": []
          },
          {
            "id": "827",
            "code": "827",
            "label": "Windykacja i egzekucja nienależnie pobranych świadczeń pomocy społecznej",
            "children": []
          },
          {
            "id": "828",
            "code": "828",
            "label": "Obsługa osób korzystających ze świadczeń i dodatków",
            "children": [
              {
                "id": "8280",
                "code": "8280",
                "label": "Informowanie jednostek zewnętrznych o osobach korzystających ze świadczeń lub dodatków",
                "children": []
              },
              {
                "id": "8281",
                "code": "8281",
                "label": "Zaświadczenia dla świadczeniobiorców",
                "children": []
              },
              {
                "id": "8282",
                "code": "8282",
                "label": "Listy wypłat świadczeń ze składką na ZUS",
                "children": []
              },
              {
                "id": "8283",
                "code": "8283",
                "label": "Listy wypłat bez składki na ZUS",
                "children": []
              },
              {
                "id": "8284",
                "code": "8284",
                "label": "Rozliczenia składek na ZUS",
                "children": []
              },
              {
                "id": "8285",
                "code": "8285",
                "label": "Zgłoszenia świadczeniobiorców do ZUS",
                "children": []
              },
              {
                "id": "8286",
                "code": "8286",
                "label": "Obsługa finansowa świadczeń",
                "children": []
              }
            ]
          }
        ]
      },
      {
        "id": "83",
        "code": "83",
        "label": "Obsługa pozostałych świadczeń",
        "children": [
          {
            "id": "830",
            "code": "830",
            "label": "Wyjaśnienia, interpretacje, opinie, akty prawne dotyczące zagadnień z zakresu pozostałych świadczeń",
            "children": []
          },
          {
            "id": "831",
            "code": "831",
            "label": "Zaliczka alimentacyjna",
            "children": [
              {
                "id": "8310",
                "code": "8310",
                "label": "Planowanie i sprawozdawczość w zakresie zaliczki alimentacyjnej",
                "children": []
              },
              {
                "id": "8311",
                "code": "8311",
                "label": "Zaliczka alimentacyjna",
                "children": []
              },
              {
                "id": "8312",
                "code": "8312",
                "label": "Windykacja i egzekucja nienależnie pobranej zaliczki alimentacyjnej",
                "children": []
              },
              {
                "id": "8313",
                "code": "8313",
                "label": "Egzekucja zaliczki alimentacyjnej od dłużników alimentacyjnych",
                "children": []
              },
              {
                "id": "8314",
                "code": "8314",
                "label": "Zaświadczenia w sprawach zaliczki alimentacyjnej",
                "children": []
              }
            ]
          },
          {
            "id": "832",
            "code": "832",
            "label": "Świadczenia z funduszu alimentacyjnego",
            "children": [
              {
                "id": "8320",
                "code": "8320",
                "label": "Świadczenia z funduszu alimentacyjnego",
                "children": []
              },
              {
                "id": "8321",
                "code": "8321",
                "label": "Postępowanie wobec dłużników alimentacyjnych",
                "children": []
              },
              {
                "id": "8322",
                "code": "8322",
                "label": "Wpływanie na aktywizację zawodową dłużników alimentacyjnych",
                "children": []
              },
              {
                "id": "8323",
                "code": "8323",
                "label": "Postępowanie w zakresie zwrotu przez dłużnika alimentacyjnego należności z tytułu wypłaconych świadczeń z funduszu alimentacyjnego",
                "children": []
              },
              {
                "id": "8324",
                "code": "8324",
                "label": "Windykacja i egzekucja nienależnie pobranych świadczeń z funduszu alimentacyjnego",
                "children": []
              },
              {
                "id": "8325",
                "code": "8325",
                "label": "Egzekucja świadczeń z funduszu alimentacyjnego",
                "children": []
              },
              {
                "id": "8326",
                "code": "8326",
                "label": "Planowanie i sprawozdawczość w zakresie świadczeń z funduszu alimentacyjnego",
                "children": []
              }
            ]
          },
          {
            "id": "833",
            "code": "833",
            "label": "Świadczenia wychowawcze 500 plus",
            "children": []
          },
          {
            "id": "834",
            "code": "834",
            "label": "Swiadczenia z programu \"Dobry start\"",
            "children": []
          }
        ]
      },
      {
        "id": "84",
        "code": "84",
        "label": "Rehabilitacja zawodowa i społeczna osób niepełnosprawnych",
        "children": [
          {
            "id": "840",
            "code": "840",
            "label": "Wyjaśnienia, interpretacje, opinie, akty prawne dotyczące zagadnień z zakresu rehabilitacji zawodowej i społecznej",
            "children": []
          },
          {
            "id": "841",
            "code": "841",
            "label": "Zagadnienia ogólne w zakresie rehabilitacji zawodowej i społecznej osób niepełnosprawnych",
            "children": [
              {
                "id": "8410",
                "code": "8410",
                "label": "Programy działania na rzecz osób niepełnosprawnych",
                "children": []
              },
              {
                "id": "8411",
                "code": "8411",
                "label": "Realizacja i monitorowanie programów na rzecz osób niepełnosprawnych",
                "children": []
              },
              {
                "id": "8412",
                "code": "8412",
                "label": "Zadania finansowane ze środków PFRON",
                "children": []
              }
            ]
          },
          {
            "id": "842",
            "code": "842",
            "label": "Zespół do spraw orzekania o niepełnosprawności",
            "children": [
              {
                "id": "8420",
                "code": "8420",
                "label": "Powoływanie i odwoływanie członków zespołu do spraw orzekania niepełnosprawności",
                "children": []
              },
              {
                "id": "8421",
                "code": "8421",
                "label": "Orzekanie o stopniu niepełnosprawności",
                "children": []
              }
            ]
          },
          {
            "id": "843",
            "code": "843",
            "label": "Społeczna rada do spraw osób niepełnosprawnych",
            "children": []
          },
          {
            "id": "844",
            "code": "844",
            "label": "Realizacja zadań z zakresu rehabilitacji zawodowej dla instytucji",
            "children": [
              {
                "id": "8440",
                "code": "8440",
                "label": "Zwrot kosztów wynagrodzeń osób niepełnosprawnych i składek na ubezpieczenie społeczne",
                "children": []
              },
              {
                "id": "8441",
                "code": "8441",
                "label": "Zwrot kosztów przystosowania stanowisk pracy, adaptacji pomieszczeń i urządzeń do potrzeb osób niepełnosprawnych oraz kosztów zatrudnienia pracownika pomagającego pracownikowi niepełnosprawnemu",
                "children": []
              }
            ]
          },
          {
            "id": "845",
            "code": "845",
            "label": "Realizacja zadań z zakresu rehabilitacji zawodowej dla osób fizycznych",
            "children": []
          },
          {
            "id": "846",
            "code": "846",
            "label": "Realizacja zadań z zakresu rehabilitacji społecznej dla instytucji",
            "children": [
              {
                "id": "8460",
                "code": "8460",
                "label": "Dofinansowanie kosztów tworzenia i działania warsztatów terapii zajęciowej",
                "children": []
              },
              {
                "id": "8461",
                "code": "8461",
                "label": "Dofinansowanie sportu, kultury, rekreacji i turystyki osób niepełnosprawnych",
                "children": []
              },
              {
                "id": "8462",
                "code": "8462",
                "label": "Dofinansowanie sprzętu rehabilitacyjnego",
                "children": []
              }
            ]
          },
          {
            "id": "847",
            "code": "847",
            "label": "Realizacja zadań z zakresu rehabilitacji społecznej dla osób fizycznych",
            "children": [
              {
                "id": "8470",
                "code": "8470",
                "label": "Dofinansowanie uczestnictwa dorosłych osób niepełnosprawnych i ich opiekunów w turnusach rehabilitacyjnych",
                "children": []
              },
              {
                "id": "8471",
                "code": "8471",
                "label": "Dofinansowanie uczestnictwa dzieci niepełnosprawnych i ich opiekunów w turnusach rehabilitacyjnych",
                "children": []
              },
              {
                "id": "8472",
                "code": "8472",
                "label": "Dofinansowanie sprzętu rehabilitacyjnego",
                "children": []
              },
              {
                "id": "8473",
                "code": "8473",
                "label": "Dofinansowanie przedmiotów ortopedycznych i środków pomocniczych",
                "children": []
              },
              {
                "id": "8474",
                "code": "8474",
                "label": "Dofinansowanie likwidacji barier architektonicznych",
                "children": []
              },
              {
                "id": "8475",
                "code": "8475",
                "label": "Dofinansowanie likwidacji barier w komunikowaniu się",
                "children": []
              },
              {
                "id": "8476",
                "code": "8476",
                "label": "Dofinansowanie likwidacji barier technicznych",
                "children": []
              }
            ]
          }
        ]
      }
    ]
  }
];
